const DICT2: { [prop: string]: string } = {
  阿爸: 'ā bà',
  阿鼻: 'ā bí',
  阿呆: 'ā dāi',
  阿弟: 'ā dì',
  阿爹: 'ā diē',
  阿斗: 'ā dǒu',
  阿飞: 'ā fēi',
  阿哥: 'ā gē',
  阿公: 'ā gōng',
  阿訇: 'ā hōng',
  阿姐: 'ā jiě',
  阿拉: 'ā lā',
  阿妈: 'ā mā',
  阿妹: 'ā mèi',
  阿曼: 'ā màn',
  阿门: 'ā mēn',
  阿蒙: 'ā méng',
  阿片: 'ā piàn',
  阿婆: 'ā pó',
  哎呀: 'āi yā',
  哎哟: 'āi yō',
  哀号: 'āi háo',
  哀矜: 'āi jīn',
  哀乐: 'āi yuè',
  嗳酸: 'ǎi suān',
  爱好: 'ài hào',
  安分: 'ān fèn',
  拗断: 'ǎo duàn',
  巴结: 'bā jì',
  扒糕: 'pá gāo',
  扒灰: 'pá huī',
  扒窃: 'pá qiè',
  扒手: 'pá shǒu',
  吧嗒: 'bā dā',
  吧唧: 'bā jī',
  吧女: 'bā nǚ',
  吧台: 'bā tái',
  把子: 'bà zi',
  白发: 'bái fà',
  白干: 'bái qián',
  白术: 'bái zhú',
  白相: 'bái xiàng',
  白血: 'bái xuè',
  白种: 'bái zhǒng',
  柏林: 'bó lín',
  败将: 'bài jiàng',
  败兴: 'bài xìng',
  败血: 'bài xuè',
  拜倒: 'bài dǎo',
  扳倒: 'bān dǎo',
  班禅: 'bān chán',
  班长: 'bān zhǎng',
  办差: 'bàn chāi',
  半拉: 'bàn lǎ',
  拌和: 'bàn huò',
  扮相: 'bàn xiàng',
  绊倒: 'bàn dǎo',
  拌种: 'bàn zhǒng',
  帮佣: 'bāng yōng',
  膀臂: 'bǎng bì',
  棒喝: 'bàng hè',
  磅秤: 'bàng chèng',
  包扎: 'bāo zā',
  宝藏: 'bǎo zàng',
  堡子: 'bǔ zi',
  报丧: 'bào sāng',
  暴晒: 'pù shài',
  暴行: 'bào xíng',
  陂塘: 'bēi táng',
  碑碣: 'bēi jié',
  悲咽: 'bēi yān',
  碑帖: 'bēi tiè',
  北朝: 'běi cháo',
  北曲: 'běi qǔ',
  备查: 'bèi zhā',
  背榜: 'bēi bǎng',
  背包: 'bēi bāo',
  背带: 'bēi dài',
  背负: 'bēi fù',
  背筐: 'bēi kuāng',
  背篓: 'bēi lǒu',
  背债: 'bēi zhài',
  背子: 'bēi zi',
  被难: 'bèi nàn',
  被子: 'bèi zi',
  奔命: 'bèn mìng',
  奔丧: 'bēn sāng',
  奔头: 'bèn tóu',
  贲门: 'bēn mén',
  本分: 'běn fèn',
  本相: 'běn xiàng',
  畚斗: 'běn dòu',
  绷脸: 'běng liǎn',
  逼肖: 'bī xiào',
  比干: 'bǐ gàn',
  吡啶: 'bǐ dìng',
  吡咯: 'bǐ gē',
  笔调: 'bǐ diào',
  笔削: 'bǐ xuē',
  鄙薄: 'bǐ bó',
  必得: 'bì děi',
  毕剥: 'bì bāo',
  毕肖: 'bì xiào',
  闭塞: 'bì sè',
  狴犴: 'bì àn',
  裨将: 'pí jiàng',
  裨益: 'bì yì',
  辟谷: 'bì gǔ',
  辟邪: 'bì xié',
  碧血: 'bì xuè',
  避难: 'bì nàn',
  臂膀: 'bì bǎng',
  璧还: 'bì huán',
  边卡: 'biān qiǎ',
  边塞: 'biān sài',
  扁担: 'biǎn dàn',
  扁舟: 'piān zhōu',
  拚命: 'pàn mìng',
  便了: 'biàn liǎo',
  便溺: 'biàn niào',
  便人: 'pián rén',
  便血: 'biàn xuè',
  便宜: 'pián yí',
  变调: 'biàn diào',
  变更: 'biàn gēng',
  变量: 'biàn liàng',
  变相: 'biàn xiàng',
  变种: 'biàn zhǒng',
  辩难: 'biàn nàn',
  标的: 'biāo dì',
  标量: 'biāo liàng',
  标识: 'biāo zhì',
  表率: 'biǎo shuài',
  憋闷: 'biē mèn',
  别传: 'bié zhuàn',
  别扭: 'biè niǔ',
  瘪三: 'biē sān',
  傧相: 'bīn xiàng',
  槟子: 'bīn zǐ',
  鬓发: 'bìn fà',
  兵差: 'bīng chāi',
  兵种: 'bīng zhǒng',
  饼铛: 'bǐng chēng',
  并处: 'bìng chǔ',
  并行: 'bìng xíng',
  剥除: 'bāo chú',
  剥剥: 'bāo bāo',
  剥壳: 'bāo ké',
  剥取: 'bāo qǔ',
  剥皮: 'bāo pí',
  剥脱: 'bāo tuō',
  剥削: 'bō xuē',
  脖颈: 'bó gěng',
  播种: 'bō zhǒng',
  伯伯: 'bó bo',
  驳倒: 'bó dǎo',
  泊车: 'bó chē',
  泊位: 'bó wèi',
  博得: 'bó de',
  搏斗: 'bó dòu',
  薄产: 'bó chǎn',
  薄待: 'bó dài',
  薄荷: 'bò he',
  薄技: 'bó jì',
  薄酒: 'bó jiǔ',
  薄利: 'bó lì',
  薄命: 'bó mìng',
  薄暮: 'bó mù',
  薄情: 'bó qíng',
  薄弱: 'bó ruò',
  薄田: 'bó tián',
  薄雾: 'bó wù',
  薄晓: 'bó xiǎo',
  薄幸: 'bó xìng',
  跛行: 'bǒ xíng',
  簸箕: 'bò ji',
  簸荡: 'bǒ dàng',
  簸动: 'bǒ dòng',
  簸弄: 'bǒ nòng',
  簸箩: 'bǒ luó',
  补给: 'bǔ jǐ',
  补假: 'bǔ jià',
  补血: 'bǔ xuè',
  不当: 'bù dàng',
  不到: 'bú dào',
  不对: 'bú duì',
  不干: 'bù gàn',
  不会: 'bú huì',
  不见: 'bú jiàn',
  不禁: 'bù jīn',
  不了: 'bù liǎo',
  不舍: 'bù shě',
  不是: 'bú shì',
  不遂: 'bù suí',
  不肖: 'bù xiào',
  不行: 'bù xíng',
  不要: 'bú yào',
  不义: 'bú yì',
  不只: 'bù zhǐ',
  不住: 'bú zhù',
  步调: 'bù diào',
  步行: 'bù xíng',
  部长: 'bù zhǎng',
  部分: 'bù fèn',
  部将: 'bù jiàng',
  簿册: 'bù cè',
  簿籍: 'bù jí',
  簿记: 'bù jì',
  簿子: 'bù zǐ',
  猜度: 'cāi duó',
  才分: 'cái fèn',
  才干: 'cái gàn',
  财会: 'cái kuài',
  裁度: 'cái duó',
  裁处: 'cái chǔ',
  裁缝: 'cái féng',
  裁量: 'cái liàng',
  采邑: 'cài yì',
  采种: 'cǎi zhǒng',
  参差: 'cēn cī',
  参禅: 'cān chán',
  参错: 'cēn cuò',
  参量: 'cān liàng',
  参商: 'shēn shāng',
  参校: 'cān jiào',
  参与: 'cān yù',
  蚕种: 'cán zhǒng',
  惭怍: 'cán zuò',
  仓颉: 'cāng jié',
  仓卒: 'cāng cù',
  伧俗: 'cāng sú',
  苍劲: 'cāng jìng',
  苍术: 'cāng zhú',
  藏蓝: 'zàng lán',
  藏历: 'zàng lì',
  藏青: 'zàng qīng',
  藏戏: 'zàng xì',
  藏族: 'zàng zú',
  操行: 'cāo xíng',
  草垛: 'cǎo duǒ',
  草率: 'cǎo shuài',
  测度: 'cè duó',
  插曲: 'chā qǔ',
  查查: 'zhā zhā',
  查处: 'chá chǔ',
  查岗: 'zhā gǎng',
  查核: 'zhā hé',
  查缉: 'zhā jī',
  查检: 'zhā jiǎn',
  查看: 'zhā kàn',
  查勤: 'zhā qín',
  查帐: 'zhā zhàng',
  查照: 'zhā zhào',
  茶几: 'chá jī',
  差别: 'chā bié',
  差池: 'chā chí',
  差错: 'chā cuò',
  差额: 'chā é',
  差价: 'chā jià',
  差可: 'chā kě',
  差距: 'chā jù',
  差使: 'chāi shǐ',
  差遣: 'chāi qiǎn',
  差事: 'chāi shì',
  差数: 'chā shù',
  差异: 'chā yì',
  差役: 'chāi yì',
  柴垛: 'chái duǒ',
  掺和: 'chān huo',
  搀和: 'chān huo',
  婵媛: 'chán yuán',
  禅定: 'chán dìng',
  禅房: 'chán fáng',
  禅机: 'chán jī',
  禅林: 'chán lín',
  禅门: 'chán mén',
  禅师: 'chán shī',
  禅堂: 'chán táng',
  禅悟: 'chán wù',
  禅心: 'chán xīn',
  禅学: 'chán xué',
  禅意: 'chán yì',
  禅院: 'chán yuàn',
  禅杖: 'chán zhàng',
  禅宗: 'chán zōng',
  产假: 'chǎn jià',
  产量: 'chǎn liàng',
  颤栗: 'zhàn lì',
  长辈: 'zhǎng bèi',
  长膘: 'zhǎng biāo',
  长大: 'zhǎng dà',
  长调: 'cháng diào',
  长发: 'cháng fà',
  长房: 'zhǎng fáng',
  长官: 'zhǎng guān',
  长假: 'cháng jià',
  长进: 'zhǎng jìn',
  长老: 'zhǎng lǎo',
  长吏: 'zhǎng lì',
  长亲: 'zhǎng qīn',
  长上: 'zhǎng shàng',
  长势: 'zhǎng shì',
  长孙: 'zhǎng sūn',
  长物: 'zhàng wù',
  长相: 'zhǎng xiàng',
  长兄: 'zhǎng xiōng',
  长者: 'zhǎng zhě',
  长子: 'zhǎng zǐ',
  偿还: 'cháng huán',
  厂长: 'chǎng zhǎng',
  场子: 'chǎng zi',
  场院: 'cháng yuàn',
  畅行: 'chàng xíng',
  唱和: 'chàng hè',
  抄查: 'chāo zhā',
  超载: 'chāo zài',
  朝拜: 'cháo bài',
  朝代: 'cháo dài',
  朝臣: 'cháo chén',
  朝服: 'cháo fú',
  朝纲: 'cháo gāng',
  朝贡: 'cháo gòng',
  朝见: 'cháo jiàn',
  朝觐: 'cháo jìn',
  朝日: 'cháo rì',
  朝上: 'cháo shàng',
  朝圣: 'cháo shèng',
  朝天: 'cháo tiān',
  朝廷: 'cháo tíng',
  朝阳: 'zhāo cháo yáng',
  朝向: 'cháo xiàng',
  朝野: 'cháo yě',
  朝政: 'cháo zhèng',
  朝着: 'cháo zhe',
  嘲哳: 'zhāo zhā',
  吵吵: 'chāo chao',
  车行: 'chē xíng',
  车载: 'chē zài',
  车子: 'chē zi',
  彻查: 'chè zhā',
  撤差: 'chè chāi',
  沉没: 'chén mò',
  沉闷: 'chén mèn',
  沉着: 'chén zhuó',
  闯将: 'chuǎng jiàng',
  称身: 'chèn shēn',
  称为: 'chēng wéi',
  称心: 'chèn xīn',
  称愿: 'chèn yuàn',
  称职: 'chèn zhí',
  趁空: 'chèn kòng',
  丞相: 'chéng xiàng',
  成长: 'chéng zhǎng',
  成分: 'chéng fèn',
  成为: 'chéng wéi',
  承载: 'chéng zài',
  诚朴: 'chéng piáo',
  城垛: 'chéng duǒ',
  乘兴: 'chéng xìng',
  惩处: 'chéng chǔ',
  澄沙: 'dèng shā',
  秤杆: 'chèng gǎn',
  吃相: 'chī xiàng',
  匙子: 'chí zi',
  尺子: 'chǐ zi',
  叱喝: 'chì hè',
  翅鞘: 'chì qiào',
  充分: 'chōng fèn',
  充塞: 'chōng sè',
  充血: 'chōng xuè',
  冲床: 'chòng chuáng',
  冲劲: 'chòng jìn',
  冲孔: 'chòng kǒng',
  冲量: 'chōng liàng',
  冲压: 'chòng yā',
  冲子: 'chòng zi',
  抽查: 'chōu zhā',
  抽调: 'chōu diào',
  绸缪: 'chóu móu',
  愁闷: 'chóu mèn',
  稠糊: 'chóu hū',
  酬和: 'chóu hè',
  丑角: 'chǒu jué',
  丑相: 'chǒu xiàng',
  丑行: 'chǒu xíng',
  出差: 'chū chāi',
  出落: 'chū là',
  出没: 'chū mò',
  出塞: 'chū sài',
  出丧: 'chū sāng',
  出行: 'chū xíng',
  出血: 'chū xuè',
  锄头: 'chú tou',
  储量: 'chǔ liàng',
  处罚: 'chǔ fá',
  处处: 'chǔ chù',
  处方: 'chǔ fāng',
  处分: 'chǔ fèn',
  处境: 'chǔ jìng',
  处理: 'chǔ lǐ',
  处决: 'chǔ jué',
  处女: 'chǔ nǚ',
  处士: 'chǔ shì',
  处身: 'chǔ shēn',
  处世: 'chǔ shì',
  处事: 'chǔ shì',
  处暑: 'chǔ shǔ',
  处死: 'chǔ sǐ',
  处刑: 'chǔ xíng',
  处于: 'chǔ yú',
  处治: 'chǔ zhì',
  处置: 'chǔ zhì',
  处子: 'chǔ zǐ',
  揣度: 'chuǎi duó',
  穿行: 'chuān xíng',
  传记: 'zhuàn jì',
  传略: 'zhuàn lüè',
  传种: 'chuán zhǒng',
  创痕: 'chuāng hén',
  创口: 'chuāng kǒu',
  创面: 'chuāng miàn',
  创伤: 'chuāng shāng',
  创痛: 'chuāng tòng',
  春假: 'chūn jià',
  春卷: 'chūn juǎn',
  纯朴: 'chún piáo',
  纯种: 'chún zhǒng',
  醇朴: 'chún piáo',
  词调: 'cí diào',
  词曲: 'cí qǔ',
  辞行: 'cí xíng',
  次长: 'cì zhǎng',
  刺啦: 'cī lā',
  刺溜: 'cī liū',
  刺痒: 'cì yáng',
  摧折: 'cuī shé',
  村长: 'cūn zhǎng',
  存查: 'cún zhā',
  忖度: 'cǔn duó',
  忖量: 'cǔn liàng',
  错处: 'cuò chǔ',
  搭载: 'dā zài',
  嗒嗒: 'dā dā',
  答理: 'dā lǐ',
  答腔: 'dā qiāng',
  答应: 'dā yìng',
  答允: 'dā yǔn',
  打杈: 'dǎ chà',
  打颤: 'dǎ zhàn',
  打场: 'dǎ cháng',
  打倒: 'dǎ dǎo',
  打斗: 'dǎ dòu',
  打呃: 'dǎ e',
  打更: 'dǎ gēng',
  打量: 'dǎ liang',
  打中: 'dǎ zhòng',
  大藏: 'dà zàng',
  大城: 'dài chéng',
  大调: 'dà diào',
  大夫: 'dài fū',
  大干: 'dà gàn',
  大亨: 'dà hēng',
  大黄: 'dài huáng',
  大将: 'dà jiàng',
  大嚼: 'dà jué',
  大量: 'dà liàng',
  大溜: 'dà liù',
  大率: 'dà shuài',
  大难: 'dà nàn',
  大王: 'dài wáng',
  大厦: 'dà shà',
  大雅: 'dà yá',
  大子: 'tài zǐ',
  代为: 'dài wéi',
  代行: 'dài xíng',
  待查: 'dài zhā',
  丹参: 'dān shēn',
  单薄: 'dān bó',
  单调: 'dān diào',
  单干: 'dān gàn',
  单行: 'dān xíng',
  单姓: 'shàn xìng',
  单于: 'chán yú',
  单子: 'dān zi',
  担子: 'dàn zi',
  胆量: 'dǎn liàng',
  旦角: 'dàn jué',
  弹腿: 'dàn tuǐ',
  弹丸: 'dàn wán',
  弹药: 'dàn yào',
  弹子: 'dàn zǐ',
  澹澹: 'dàn dàn',
  当差: 'dāng chāi',
  当朝: 'dāng cháo',
  当成: 'dàng chéng',
  当量: 'dāng liàng',
  当票: 'dàng piào',
  当铺: 'dàng pù',
  当天: 'dàng tiān',
  当晚: 'dàng wǎn',
  当夜: 'dàng yè',
  当月: 'dàng yuè',
  当真: 'dàng zhēn',
  当作: 'dàng zuò',
  当做: 'dàng zuò',
  党参: 'dǎng shēn',
  刀把: 'dāo bà',
  刀鞘: 'dāo qiào',
  叨叨: 'dāo dao',
  叨咕: 'dáo gu',
  叨唠: 'dāo lao',
  叨光: 'tāo guāng',
  叨扰: 'tāo rǎo',
  导弹: 'dǎo dàn',
  倒把: 'dǎo bǎ',
  倒班: 'dǎo bān',
  倒包: 'dǎo bāo',
  倒闭: 'dǎo bì',
  倒毙: 'dǎo bì',
  倒仓: 'dǎo cāng',
  倒茬: 'dǎo chá',
  倒垂: 'dǎo chuí',
  倒错: 'dǎo cuò',
  倒地: 'dǎo dì',
  倒反: 'dǎo fǎn',
  倒伏: 'dǎo fú',
  倒戈: 'dǎo gē',
  倒阁: 'dǎo gé',
  倒换: 'dǎo huàn',
  倒嚼: 'dǎo jiào',
  倒卖: 'dǎo mài',
  倒霉: 'dǎo méi',
  倒弄: 'dǎo nòng',
  倒嗓: 'dǎo sǎng',
  倒是: 'dǎo shì',
  倒手: 'dǎo shǒu',
  倒数: 'dào shǔ',
  倒算: 'dǎo suàn',
  倒塌: 'dǎo tā',
  倒台: 'dǎo tái',
  倒坍: 'dǎo tān',
  倒腾: 'dǎo téng',
  倒替: 'dǎo tì',
  倒头: 'dǎo tóu',
  倒下: 'dǎo xià',
  倒休: 'dǎo xiū',
  倒序: 'dǎo xù',
  倒牙: 'dǎo yá',
  倒爷: 'dǎo yé',
  倒运: 'dǎo yùn',
  倒灶: 'dǎo zào',
  倒账: 'dǎo zhàng',
  倒找: 'dǎo zhǎo',
  倒座: 'dǎo zuò',
  道藏: 'dào zàng',
  道观: 'dào guàn',
  道行: 'dào héng',
  得当: 'dé dàng',
  德行: 'dé xíng',
  的当: 'dí dàng',
  的确: 'dí què',
  的士: 'dí shì',
  等量: 'děng liàng',
  低调: 'dī diào',
  嘀嗒: 'dī dā',
  敌忾: 'dí kài',
  底子: 'dǐ zi',
  地磅: 'dì bàng',
  地堡: 'dì pù',
  地处: 'dì chǔ',
  地壳: 'dì qiào',
  弟弟: 'dì di',
  递解: 'dì jiè',
  棣棠: 'dì táng',
  颠簸: 'diān bǒ',
  颠倒: 'diān dǎo',
  典当: 'diǎn dàng',
  点将: 'diǎn jiàng',
  点着: 'diǎn zháo',
  电量: 'diàn liàng',
  垫圈: 'diàn juàn',
  刁横: 'diāo hèng',
  刁难: 'diāo nàn',
  刁钻: 'diāo zuān',
  吊丧: 'diào sāng',
  调包: 'diào bāo',
  调查: 'diào chá',
  调处: 'tiáo chǔ',
  调调: 'tiáo diào',
  调动: 'diào dòng',
  调度: 'diào dù',
  调防: 'diào fáng',
  调干: 'diào gàn',
  调函: 'diào hán',
  调号: 'diào hào',
  调回: 'diào huí',
  调换: 'diào huàn',
  调集: 'diào jí',
  调经: 'diào jīng',
  调卷: 'diào juàn',
  调离: 'diào lí',
  调令: 'diào lìng',
  调门: 'diào mén',
  调派: 'diào pài',
  调配: 'diào pèi',
  调遣: 'diào qiǎn',
  调取: 'diào qǔ',
  调人: 'diào rén',
  调任: 'diào rèn',
  调式: 'diào shì',
  调头: 'diào tóu',
  调温: 'diào wēn',
  调研: 'diào yán',
  调演: 'diào yǎn',
  调用: 'diào yòng',
  调阅: 'diào yuè',
  调运: 'diào yùn',
  调正: 'diào zhèng',
  调值: 'diào zhí',
  调职: 'diào zhí',
  调转: 'diào zhuǎn',
  调子: 'diào zi',
  跌倒: 'diē dǎo',
  喋喋: 'dié dié',
  喋血: 'dié xuè',
  钉子: 'dīng zi',
  酊剂: 'dīng jì',
  定当: 'dìng dàng',
  定调: 'dìng diào',
  定量: 'dìng liàng',
  碇泊: 'dìng bó',
  懂得: 'dǒng de',
  动弹: 'dòng dàn',
  动量: 'dòng liàng',
  侗族: 'dòng zú',
  恫吓: 'dòng hè',
  都督: 'dū du',
  都会: 'dōu huì',
  斗法: 'dòu fǎ',
  斗富: 'dòu fù',
  斗鸡: 'dòu jī',
  斗箕: 'dòu ji',
  斗牛: 'dòu niú',
  斗殴: 'dòu ōu',
  斗牌: 'dòu pái',
  斗气: 'dòu qì',
  斗士: 'dòu shì',
  斗眼: 'dòu yǎn',
  斗勇: 'dòu yǒng',
  斗艳: 'dòu yàn',
  斗争: 'dòu zhēng',
  斗志: 'dòu zhì',
  斗智: 'dòu zhì',
  斗子: 'dǒu zi',
  斗嘴: 'dòu zuǐ',
  抖搂: 'dǒu lōu',
  抖擞: 'dǒu sǒu',
  逗哏: 'dòu gén',
  督率: 'dū shuài',
  独处: 'dú chǔ',
  独行: 'dú xíng',
  笃行: 'dǔ xíng',
  堵塞: 'dǔ sè',
  肚量: 'dù liàng',
  肚子: 'dǔ zi',
  度量: 'dù liàng',
  度假: 'dù jià',
  度曲: 'dù qǔ',
  断种: 'duàn zhǒng',
  锻模: 'duàn mú',
  队长: 'duì zhǎng',
  对簿: 'duì bù',
  对称: 'duì chèn',
  对调: 'duì diào',
  敦朴: 'dūn piáo',
  多咱: 'duō zá',
  夺得: 'duó de',
  夺冠: 'duó guàn',
  垛口: 'duǒ kǒu',
  垛子: 'duǒ zi',
  蛾子: 'é zi',
  婀娜: 'ē nuó',
  厄难: 'è nàn',
  恶斗: 'è dòu',
  恶少: 'è shào',
  恶相: 'è xiàng',
  恶心: 'ě xīn',
  恶行: 'è xíng',
  二重: 'èr chóng',
  发辫: 'fà biàn',
  发鬓: 'fà bìn',
  发菜: 'fà cài',
  发还: 'fā huán',
  发髻: 'fà jì',
  发际: 'fà jì',
  发夹: 'fā jiā',
  发卡: 'fà qiǎ',
  发廊: 'fà láng',
  发闷: 'fā mèn',
  发蒙: 'fā mēng',
  发难: 'fā nàn',
  发妻: 'fà qī',
  发乳: 'fà rǔ',
  发丧: 'fā sāng',
  发式: 'fà shì',
  发屋: 'fà wū',
  发行: 'fā xíng',
  发型: 'fà xíng',
  发怔: 'fā zhèng',
  发指: 'fà zhǐ',
  法帖: 'fǎ tiè',
  番禺: 'pān yú',
  翻查: 'fān zhā',
  翻倒: 'fān dǎo',
  翻卷: 'fān juǎn',
  烦闷: 'fán mèn',
  反弹: 'fǎn dàn',
  反调: 'fǎn diào',
  反间: 'fǎn jiàn',
  反省: 'fǎn xǐng',
  返还: 'fǎn huán',
  饭量: 'fàn liàng',
  防弹: 'fáng dàn',
  仿佛: 'fǎng fú',
  仿行: 'fǎng xíng',
  访查: 'fǎng zhā',
  放倒: 'fàng dǎo',
  放假: 'fàng jià',
  放量: 'fàng liàng',
  放行: 'fàng xíng',
  放血: 'fàng xuè',
  飞弹: 'fēi dàn',
  飞行: 'fēi xíng',
  飞转: 'fēi zhuàn',
  妃嫔: 'fēi pín',
  妃子: 'fēi zǐ',
  非得: 'fēi děi',
  非分: 'fēi fèn',
  非难: 'fēi nàn',
  菲仪: 'fěi yí',
  菲薄: 'fěi bó',
  分叉: 'fēn chà',
  分当: 'fèn dāng',
  分得: 'fēn de',
  分量: 'fèn liàng',
  分内: 'fèn nèi',
  分散: 'fēn sǎn',
  分外: 'fèn wài',
  分为: 'fēn wéi',
  分子: 'fèn zǐ',
  粉坊: 'fěn fáng',
  份量: 'fèn liàng',
  份子: 'fèn zi',
  奋斗: 'fèn dòu',
  风量: 'fēng liàng',
  风靡: 'fēng mǐ',
  风头: 'fēng tou',
  风行: 'fēng xíng',
  缝补: 'féng bǔ',
  缝合: 'féng hé',
  缝纫: 'féng rèn',
  缝衣: 'féng yī',
  缝制: 'féng zhì',
  缝缀: 'féng zhuì',
  缝子: 'fèng zi',
  凤爪: 'fèng zhǎo',
  奉还: 'fèng huán',
  奉行: 'fèng xíng',
  伏帖: 'fú tiē',
  服丧: 'fú sāng',
  服帖: 'fú tiē',
  福相: 'fú xiàng',
  负载: 'fù zài',
  附和: 'fù hè',
  附识: 'fù zhì',
  附着: 'fù zhuó',
  复辟: 'fù bì',
  复查: 'fù zhā',
  复种: 'fù zhǒng',
  赴难: 'fù nàn',
  覆没: 'fù mò',
  嘎巴: 'gā bā',
  嘎噔: 'gā dēng',
  嘎嘎: 'gā gā',
  嘎啦: 'gā lā',
  嘎然: 'gā rán',
  嘎吱: 'gā zhī',
  该着: 'gāi zháo',
  改调: 'gǎi diào',
  改为: 'gǎi wéi',
  盖子: 'gài zi',
  干白: 'gàn bái',
  干部: 'gàn bù',
  干才: 'gàn cái',
  干道: 'gàn dào',
  干点: 'gàn diǎn',
  干掉: 'gàn diào',
  干粉: 'gàn fěn',
  干干: 'gàn gàn',
  干号: 'gān háo',
  干活: 'gàn huó',
  干架: 'gàn jià',
  干将: 'gàn jiàng',
  干结: 'gàn jié',
  干劲: 'gàn jìn',
  干警: 'gàn jǐng',
  干练: 'gàn liàn',
  干流: 'gàn liú',
  干路: 'gàn lù',
  干吗: 'gàn má',
  干嘛: 'gàn ma',
  干么: 'gàn mǒ',
  干渠: 'gàn qú',
  干事: 'gàn shì',
  干松: 'gàn sōng',
  干线: 'gàn xiàn',
  干校: 'gàn xiào',
  干硬: 'gàn yìng',
  干预: 'gàn yù',
  干员: 'gàn yuán',
  干政: 'gàn zhèng',
  干仗: 'gàn zhàng',
  杆秤: 'gǎn chèng',
  杆菌: 'gǎn jūn',
  杆塔: 'gǎn tǎ',
  杆子: 'gān zi',
  刚劲: 'gāng jìng',
  钢种: 'gāng zhǒng',
  杠杆: 'gàng gǎn',
  杠子: 'gàng zi',
  皋兰: 'gāo lán',
  高调: 'gāo diào',
  高干: 'gāo gàn',
  高丽: 'gāo lí',
  高挑: 'gāo tiǎo',
  高兴: 'gāo xìng',
  高知: 'gāo zhì',
  膏血: 'gāo xuè',
  膏泽: 'gào zé',
  篙头: 'gāo tou',
  镐头: 'gǎo tóu',
  告倒: 'gào dǎo',
  告假: 'gào jià',
  疙瘩: 'gē dā',
  胳臂: 'gē bei',
  胳膊: 'gē bo',
  割切: 'gē qiē',
  歌曲: 'gē qǔ',
  歌行: 'gē xíng',
  格调: 'gé diào',
  格斗: 'gé dòu',
  葛布: 'gé bù',
  葛粉: 'gé fěn',
  葛根: 'gé gēn',
  葛藤: 'gé téng',
  蛤粉: 'gé fěn',
  蛤蚧: 'gé jiè',
  蛤蜊: 'gé lí',
  蛤蟆: 'há má',
  隔扇: 'gé shān',
  个子: 'gè zi',
  各种: 'gè zhǒng',
  给水: 'jǐ shuǐ',
  给养: 'jǐ yǎng',
  给予: 'jǐ yǔ',
  跟差: 'gēn chāi',
  跟头: 'gēn tou',
  更次: 'gēng cì',
  更迭: 'gēng dié',
  更动: 'gēng dòng',
  更番: 'gēng fān',
  更夫: 'gēng fū',
  更改: 'gēng gǎi',
  更鼓: 'gēng gǔ',
  更换: 'gēng huàn',
  更名: 'gēng míng',
  更深: 'gēng shēn',
  更生: 'gēng shēng',
  更始: 'gēng shǐ',
  更替: 'gēng tì',
  更为: 'gèng wéi',
  更新: 'gēng xīn',
  更衣: 'gēng yī',
  更易: 'gēng yì',
  更张: 'gēng zhāng',
  更正: 'gēng zhèng',
  更卒: 'gēng zú',
  哽塞: 'gěng sè',
  梗塞: 'gěng sè',
  工尺: 'gōng chě',
  工种: 'gōng zhǒng',
  公差: 'gōng chāi',
  公干: 'gōng gàn',
  公假: 'gōng jià',
  公转: 'gōng zhuàn',
  供电: 'gōng diàn',
  供给: 'gōng jǐ',
  供料: 'gōng liào',
  供气: 'gōng qì',
  供求: 'gōng qiú',
  供销: 'gōng xiāo',
  供需: 'gōng xū',
  供应: 'gōng yìng',
  宫调: 'gōng diào',
  躬行: 'gōng xíng',
  拱券: 'gǒng xuàn',
  共处: 'gòng chǔ',
  勾当: 'gòu dàng',
  佝偻: 'gōu lóu',
  枸橘: 'gōu jú',
  枸杞: 'gǒu qǐ',
  购得: 'gòu de',
  够呛: 'gòu qiāng',
  估量: 'gū liang',
  估衣: 'gù yī',
  孤行: 'gū xíng',
  古朴: 'gǔ piáo',
  汩汩: 'gǔ gǔ',
  汩没: 'gǔ mò',
  谷坊: 'gǔ fáng',
  股长: 'gǔ zhǎng',
  骨朵: 'gū duǒ',
  骨干: 'gǔ gàn',
  骨碌: 'gū lù',
  骨头: 'gú tou',
  骨血: 'gǔ xuè',
  骨殖: 'gǔ shi',
  骨子: 'gǔ zi',
  榾柮: 'gǔ duò',
  鼓乐: 'gǔ yuè',
  故伎: 'gù jì',
  固着: 'gù zhuó',
  雇佣: 'gù yōng',
  瓜蔓: 'guā wàn',
  瓜葛: 'guā gé',
  呱嗒: 'guā dā',
  呱唧: 'guā jī',
  呱呱: 'gū gū',
  怪相: 'guài xiàng',
  关卡: 'guān qiǎ',
  官差: 'guān chāi',
  官长: 'guān zhǎng',
  官倒: 'guān dǎo',
  冠军: 'guàn jūn',
  冠礼: 'guàn lǐ',
  冠子: 'guàn zi',
  管乐: 'guǎn yuè',
  光杆: 'guāng gǎn',
  光晕: 'guāng yùn',
  光栅: 'guāng shān',
  桄榔: 'guāng láng',
  广厦: 'guǎng shà',
  归还: 'guī huán',
  归降: 'guī xiáng',
  归省: 'guī xǐng',
  龟甲: 'guī jiá',
  龟裂: 'jūn liè',
  鲑鱼: 'guī yú',
  柜子: 'guì zi',
  贵处: 'guì chǔ',
  贵妃: 'guì fēi',
  贵干: 'guì gàn',
  跪倒: 'guì dǎo',
  棍子: 'gùn zi',
  国难: 'guó nàn',
  国丧: 'guó sāng',
  果干: 'guǒ gàn',
  过磅: 'guò bàng',
  过分: 'guò fèn',
  过量: 'guò liàng',
  过载: 'guò zài',
  哈达: 'hǎ dá',
  哈罗: 'hā luo',
  嗨哟: 'hāi yō',
  海参: 'hǎi shēn',
  海量: 'hǎi liàng',
  海难: 'hǎi nàn',
  含糊: 'hán hu',
  含量: 'hán liàng',
  含血: 'hán xuè',
  寒颤: 'hán zhàn',
  寒假: 'hán jià',
  悍将: 'hàn jiàng',
  航行: 'háng xíng',
  豪横: 'háo hèng',
  豪兴: 'háo xìng',
  好动: 'hào dòng',
  好斗: 'hào dòu',
  好恶: 'hào wù',
  好古: 'hào gǔ',
  好客: 'hào kè',
  好奇: 'hào qí',
  好强: 'hào qiáng',
  好色: 'hào sè',
  好胜: 'hào shèng',
  好学: 'hào xué',
  好战: 'hào zhàn',
  号叫: 'háo jiào',
  号丧: 'háo sāng',
  号啕: 'háo táo',
  呵喝: 'hē hè',
  呵责: 'hē zé',
  喝采: 'hè cǎi',
  喝彩: 'hè cǎi',
  喝道: 'hè dào',
  喝令: 'hè lìng',
  喝问: 'hè wèn',
  禾场: 'hé cháng',
  何处: 'hé chǔ',
  何曾: 'hé zēng',
  和面: 'huó miàn',
  和弄: 'huò nòng',
  和诗: 'hè shī',
  核查: 'hé zhā',
  核弹: 'hé dàn',
  核儿: 'hú ér',
  荷载: 'hè zǎi',
  貉绒: 'háo róng',
  貉子: 'háo zi',
  黑种: 'hēi zhǒng',
  恒量: 'héng liàng',
  亨通: 'hēng tōng',
  横暴: 'hèng bào',
  横财: 'hèng cái',
  横祸: 'hèng huò',
  横逆: 'hèng nì',
  横蛮: 'hèng mán',
  横事: 'hèng shì',
  横死: 'hèng sǐ',
  横行: 'héng xíng',
  哄传: 'hōng chuán',
  哄动: 'hōng dòng',
  哄闹: 'hōng nào',
  哄抢: 'hōng qiǎng',
  哄然: 'hōng rán',
  哄抬: 'hōng tái',
  哄堂: 'hōng táng',
  哄笑: 'hōng xiào',
  红曲: 'hóng qǔ',
  红苕: 'hóng sháo',
  红晕: 'hóng yùn',
  宏量: 'hóng liàng',
  洪量: 'hóng liàng',
  鸿爪: 'hóng zhǎo',
  后妃: 'hòu fēi',
  后头: 'hòu tou',
  厚朴: 'hòu pò',
  呼号: 'hū háo',
  呼喝: 'hū hè',
  呼啦: 'hū lā',
  呼吁: 'hū yù',
  狐臊: 'hú sāo',
  胡同: 'hú tòng',
  糊糊: 'hū hū',
  糊弄: 'hù nòng',
  虎贲: 'hǔ bēn',
  虎将: 'hǔ jiàng',
  互见: 'hù xiàn',
  户调: 'hù diào',
  花卷: 'huā juǎn',
  花呢: 'huā ní',
  华发: 'huá fà',
  华山: 'huà shān',
  华佗: 'huà tuó',
  哗啦: 'huā lā',
  哗哗: 'huā huā',
  滑行: 'huá xíng',
  划船: 'huá chuán',
  划过: 'huá guò',
  划划: 'huá huá',
  划桨: 'huá jiǎng',
  划拉: 'huá lā',
  划拳: 'huá quán',
  划算: 'huá suàn',
  划艇: 'huá tǐng',
  划行: 'huá xíng',
  划子: 'huá zǐ',
  画夹: 'huà jiā',
  画片: 'huà piān',
  画帖: 'huà tiè',
  坏种: 'huài zhǒng',
  还本: 'huán běn',
  还击: 'huán jī',
  还魂: 'huán hún',
  还价: 'huán jià',
  还口: 'huán kǒu',
  还清: 'huán qīng',
  还礼: 'huán lǐ',
  还手: 'huán shǒu',
  还俗: 'huán sú',
  还席: 'huán xí',
  还乡: 'huán xiāng',
  还阳: 'huán yáng',
  还原: 'huán yuán',
  还愿: 'huán yuàn',
  还债: 'huán zhài',
  还账: 'huán zhàng',
  还嘴: 'huán zuǐ',
  环行: 'huán xíng',
  缓行: 'huǎn xíng',
  唤头: 'huàn tou',
  皇朝: 'huáng cháo',
  皇妃: 'huáng fēi',
  晃眼: 'huǎng yǎn',
  晃晃: 'huàng huǎng',
  徽调: 'huī diào',
  回还: 'huí huán',
  回帖: 'huí tiē',
  会儿: 'huì er',
  会计: 'kuài jì',
  浑朴: 'hún piáo',
  混血: 'hùn xuè',
  豁出: 'huō chū',
  豁口: 'huō kǒu',
  豁拳: 'huó quán',
  豁子: 'huō zǐ',
  豁嘴: 'huō zuǐ',
  活血: 'huó xuè',
  火种: 'huǒ zhǒng',
  击中: 'jī zhòng',
  机长: 'jī zhǎng',
  积累: 'jī lěi',
  缉捕: 'jī bǔ',
  缉查: 'jī zhā',
  缉获: 'jī huò',
  缉拿: 'jī ná',
  缉凶: 'jī xiōng',
  缉私: 'jī sī',
  箕斗: 'jī dòu',
  稽查: 'jī zhā',
  稽首: 'qǐ shǒu',
  激将: 'jī jiàng',
  即兴: 'jí xìng',
  即行: 'jí xíng',
  极量: 'jí liàng',
  极为: 'jí wéi',
  亟亟: 'jí jí',
  急难: 'jí nàn',
  疾行: 'jí xíng',
  籍没: 'jí mò',
  几案: 'jī àn',
  几乎: 'jī hū',
  几率: 'jī lǜ',
  几微: 'jī wēi',
  几希: 'jī xī',
  几曾: 'jǐ zēng',
  几至: 'jī zhì',
  记得: 'jì de',
  伎俩: 'jì liǎng',
  纪行: 'jì xíng',
  剂量: 'jì liàng',
  济南: 'jǐ nán',
  偈语: 'jì yǔ',
  夹板: 'jiā bǎn',
  夹层: 'jiā céng',
  夹持: 'jiā chí',
  夹带: 'jiā dài',
  夹道: 'jiā dào',
  夹缝: 'jiā fèng',
  夹攻: 'jiā gōng',
  夹棍: 'jiā gùn',
  夹击: 'jiā jī',
  夹剪: 'jiā jiǎn',
  夹角: 'jiā jiǎo',
  夹紧: 'jiā jǐn',
  夹具: 'jiā jù',
  夹批: 'jiā pī',
  夹钳: 'jiā qián',
  夹墙: 'jiā qiáng',
  夹生: 'jiā shēng',
  夹馅: 'jiā xiàn',
  夹心: 'jiā xīn',
  夹杂: 'jiā zá',
  夹峙: 'jiā zhì',
  夹子: 'jiā zi',
  夹注: 'jiā zhù',
  家长: 'jiā zhǎng',
  家当: 'jiā dàng',
  家伙: 'jiā huo',
  家累: 'jiā lěi',
  家雀: 'jiā qiǎo',
  家什: 'jiā shí',
  甲壳: 'jiǎ qiào',
  贾祸: 'gǔ huò',
  贾人: 'gǔ rén',
  间谍: 'jiàn dié',
  间断: 'jiàn duàn',
  间隔: 'jiàn gé',
  间或: 'jiàn huò',
  间接: 'jiàn jiē',
  间量: 'jiān liàng',
  间苗: 'jiàn miáo',
  间色: 'jiàn sè',
  间隙: 'jiàn xì',
  间歇: 'jiàn xiē',
  间种: 'jiàn zhòng',
  间奏: 'jiàn zòu',
  间作: 'jiàn zuò',
  兼差: 'jiān chāi',
  犍牛: 'jiān niú',
  犍为: 'qián wéi',
  剪发: 'jiǎn fà',
  简朴: 'jiǎn piáo',
  简帖: 'jiǎn tiē',
  见长: 'jiàn zhǎng',
  见得: 'jiàn de',
  饯行: 'jiàn xíng',
  健将: 'jiàn jiàng',
  践行: 'jiàn xíng',
  腱鞘: 'jiàn qiào',
  箭垛: 'jiàn duǒ',
  将官: 'jiàng guān',
  将将: 'qiāng qiāng',
  将令: 'jiàng lìng',
  将领: 'jiàng lǐng',
  将门: 'jiàng mén',
  将士: 'jiàng shì',
  将帅: 'jiàng shuài',
  将尉: 'jiàng wèi',
  将校: 'jiàng xiào',
  降调: 'jiàng diào',
  降伏: 'xiáng fú',
  糨糊: 'jiàng hù',
  交差: 'jiāo chāi',
  交恶: 'jiāo wù',
  交还: 'jiāo huán',
  姣好: 'jiāo hǎo',
  姣丽: 'jiāo lì',
  姣美: 'jiāo měi',
  娇娆: 'jiāo ráo',
  浇薄: 'jiāo bó',
  骄横: 'jiāo hèng',
  浇头: 'jiāo tou',
  骄矜: 'jiāo jīn',
  胶卷: 'jiāo juǎn',
  角斗: 'jué dòu',
  角力: 'jué lì',
  角色: 'jué sè',
  角逐: 'jué zhú',
  搅和: 'jiǎo huo',
  搅混: 'jiǎo gǔn',
  湫隘: 'jiǎo ài',
  剿袭: 'chāo xí',
  徼幸: 'jiǎo xìng',
  较量: 'jiào liàng',
  较为: 'jiào wéi',
  节子: 'jiē zǐ',
  劫难: 'jié nàn',
  诘责: 'jié zé',
  拮据: 'jié jū',
  结巴: 'jiē bā',
  结发: 'jié fà',
  结实: 'jiē shi',
  结扎: 'jié zā',
  碣石: 'jié shí',
  她们: 'tā men',
  解差: 'jiè chāi',
  解法: 'xiè fǎ',
  解款: 'jiè kuǎn',
  解闷: 'jiě mèn',
  解数: 'xiè shù',
  解送: 'jiè sòng',
  解元: 'jiè yuán',
  芥蓝: 'gài lán',
  借调: 'jiè diào',
  金弹: 'jīn dàn',
  金相: 'jīn xiàng',
  矜持: 'jīn chí',
  矜贵: 'jīn guì',
  矜夸: 'jīn kuā',
  尽管: 'jǐn guǎn',
  尽快: 'jǐn kuài',
  尽量: 'jǐn liàng',
  尽先: 'jǐn xiān',
  尽兴: 'jìn xìng',
  尽责: 'jìn zé',
  尽自: 'jǐn zì',
  劲草: 'jìng cǎo',
  劲吹: 'jìng chuī',
  劲敌: 'jìng dí',
  劲风: 'jìng fēng',
  劲旅: 'jìng lǚ',
  劲射: 'jìng shè',
  劲直: 'jìng zhí',
  进给: 'jìn jǐ',
  浸没: 'jìn mò',
  浸种: 'jìn zhǒng',
  禁脔: 'jìn jī',
  禁受: 'jīn shòu',
  禁用: 'jīn yòng',
  经传: 'jīng zhuàn',
  经血: 'jīng xuè',
  茎干: 'jīng gàn',
  惊倒: 'jīng dǎo',
  精当: 'jīng dàng',
  精干: 'jīng gàn',
  精血: 'jīng xuè',
  景行: 'jǐng xíng',
  警种: 'jǐng zhǒng',
  净得: 'jìng de',
  径行: 'jìng xíng',
  靓妆: 'jìng zhuāng',
  纠葛: 'jiū gé',
  窘相: 'jiǒng xiàng',
  揪斗: 'jiū dòu',
  酒吧: 'jiǔ bā',
  酒量: 'jiǔ liàng',
  酒兴: 'jiǔ xìng',
  居处: 'jū chǔ',
  居丧: 'jū sāng',
  拘泥: 'jū nì',
  局量: 'jú liàng',
  桔槔: 'jié gāo',
  桔梗: 'jié gěng',
  咀嚼: 'jǔ jué',
  沮洳: 'jù rù',
  举行: 'jǔ xíng',
  句读: 'jù dòu',
  句子: 'jù zi',
  巨量: 'jù liàng',
  巨贾: 'jù gǔ',
  巨阙: 'jù quē',
  剧曲: 'jù qǔ',
  剧种: 'jù zhǒng',
  卷尺: 'juǎn chǐ',
  卷发: 'juǎn fà',
  卷曲: 'juǎn qū',
  卷舌: 'juǎn shé',
  卷逃: 'juǎn táo',
  卷烟: 'juǎn yān',
  卷云: 'juǎn yún',
  卷扬: 'juǎn yáng',
  卷子: 'juǎn zi',
  隽永: 'juàn yǒng',
  撅嘴: 'juē zuǐ',
  决斗: 'jué dòu',
  绝倒: 'jué dǎo',
  绝种: 'jué zhǒng',
  觉得: 'jué de',
  倔强: 'jué jiàng',
  噱头: 'xué tou',
  军长: 'jūn zhǎng',
  军乐: 'jūn yuè',
  军种: 'jūn zhǒng',
  咔嚓: 'kā chā',
  咔嗒: 'kā dā',
  咖啡: 'kā fēi',
  卡具: 'qiǎ jù',
  卡壳: 'qiǎ ké',
  卡子: 'qiǎ zi',
  开豁: 'kāi huō',
  开行: 'kāi xíng',
  剀切: 'kǎi qiē',
  刊行: 'kān xíng',
  勘查: 'kān zhā',
  勘校: 'kān jiào',
  坎坷: 'kǎn kě',
  看管: 'kān guǎn',
  看护: 'kān hù',
  看家: 'kān jiā',
  看门: 'kān mén',
  看守: 'kān shǒu',
  看头: 'kàn tou',
  看相: 'kàn xiàng',
  看押: 'kān yā',
  看中: 'kàn zhòng',
  扛鼎: 'gāng dǐng',
  考查: 'kǎo zhā',
  靠泊: 'kào bó',
  苛责: 'kē zé',
  科长: 'kē zhǎng',
  咳喘: 'ké chuǎn',
  咳嗽: 'ké sòu',
  咳血: 'ké xuè',
  可恶: 'kě wù',
  可汗: 'kè hán',
  可行: 'kě xíng',
  可曾: 'kě zēng',
  刻薄: 'kè bó',
  刻划: 'kè huá',
  空白: 'kòng bái',
  空地: 'kòng dì',
  空儿: 'kòng ér',
  空额: 'kòng é',
  空难: 'kōng nàn',
  空缺: 'kòng quē',
  空隙: 'kòng xì',
  空暇: 'kòng xiá',
  空闲: 'kòng xián',
  空余: 'kòng yú',
  空转: 'kōng zhuàn',
  空子: 'kòng zi',
  倥侗: 'kōng tóng',
  恐吓: 'kǒng hè',
  口角: 'kǒu jué',
  哭丧: 'kū sang',
  苦参: 'kǔ shēn',
  苦差: 'kǔ chāi',
  苦斗: 'kǔ dòu',
  苦处: 'kǔ chǔ',
  苦干: 'kǔ gàn',
  苦闷: 'kǔ mèn',
  苦难: 'kǔ nàn',
  苦行: 'kǔ xíng',
  快行: 'kuài xíng',
  宽绰: 'kuān chuo',
  款曲: 'kuǎn qǔ',
  款识: 'kuǎn zhì',
  亏得: 'kuī de',
  窥度: 'kuī duó',
  愧怍: 'kuì zuò',
  昆曲: 'kūn qǔ',
  困处: 'kùn chǔ',
  困觉: 'kùn jiào',
  阔少: 'kuò shào',
  拉倒: 'lā dǎo',
  拉杆: 'lā gǎn',
  拉纤: 'lā qiàn',
  喇嘛: 'lǎ ma',
  来得: 'lái de',
  来头: 'lái tou',
  兰若: 'lán rě',
  栏干: 'lán gàn',
  栏栅: 'lán shān',
  懒得: 'lǎn de',
  懒散: 'lǎn sǎn',
  滥调: 'làn diào',
  狼藉: 'láng jí',
  莨菪: 'làng dàng',
  榔头: 'láng tou',
  浪头: 'làng tou',
  唠扯: 'lào chě',
  唠嗑: 'lào kè',
  唠唠: 'lào lào',
  老调: 'lǎo diào',
  老将: 'lǎo jiàng',
  老区: 'lǎo ōu',
  老少: 'lǎo shào',
  姥姥: 'lǎo lao',
  潦倒: 'liáo dǎo',
  乐池: 'yuè chí',
  乐得: 'lè de',
  乐都: 'lè dōu',
  乐队: 'yuè duì',
  乐府: 'yuè fǔ',
  乐感: 'yuè gǎn',
  乐歌: 'yuè gē',
  乐工: 'yuè gōng',
  乐官: 'yuè guān',
  乐户: 'yuè hù',
  乐律: 'yuè lǜ',
  乐迷: 'yuè mí',
  乐谱: 'yuè pǔ',
  乐器: 'yuè qì',
  乐曲: 'yuè qǔ',
  乐师: 'yuè shī',
  乐坛: 'yuè tán',
  乐团: 'yuè tuán',
  乐舞: 'yuè wǔ',
  乐音: 'yuè yīn',
  乐章: 'yuè zhāng',
  擂鼓: 'léi gǔ',
  楞伽: 'léng jiā',
  冷颤: 'lěng zhàn',
  离间: 'lí jiàn',
  罹难: 'lí nàn',
  礼乐: 'lǐ yuè',
  里弄: 'lǐ lòng',
  里头: 'lǐ tou',
  俚曲: 'lǐ qǔ',
  力量: 'lì liàng',
  历朝: 'lì cháo',
  力行: 'lì xíng',
  历数: 'lì shǔ',
  厉行: 'lì xíng',
  丽水: 'lí shuǐ',
  利得: 'lì de',
  励行: 'lì xíng',
  例假: 'lì jià',
  例行: 'lì xíng',
  栎木: 'lì mù',
  栎树: 'lì shù',
  连杆: 'lián gǎn',
  连累: 'lián lěi',
  良将: 'liáng jiàng',
  良种: 'liáng zhǒng',
  亮相: 'liàng xiàng',
  量变: 'liàng biàn',
  量词: 'liàng cí',
  量纲: 'liàng gāng',
  量力: 'liàng lì',
  量能: 'liàng néng',
  量刑: 'liàng xíng',
  量子: 'liàng zǐ',
  了当: 'liǎo dàng',
  了得: 'liǎo de',
  了断: 'liǎo duàn',
  了结: 'liǎo jié',
  了解: 'liǎo jiě',
  了局: 'liǎo jú',
  了了: 'liǎo liǎo',
  了却: 'liǎo què',
  了然: 'liǎo rán',
  了事: 'liǎo shì',
  了无: 'liǎo wú',
  了悟: 'liǎo wù',
  了账: 'liǎo zhàng',
  料量: 'liào liàng',
  咧嘴: 'liě zuǐ',
  列传: 'liè zhuàn',
  劣种: 'liè zhǒng',
  趔趄: 'liè qie',
  临朝: 'lín cháo',
  临难: 'lín nàn',
  临帖: 'lín tiè',
  临行: 'lín xíng',
  淋病: 'lìn bìng',
  鳞爪: 'lín zhǎo',
  铃铛: 'líng dang',
  零散: 'líng sǎn',
  令狐: 'líng hú',
  另行: 'lìng xíng',
  流弹: 'liú dàn',
  流量: 'liú liàng',
  流行: 'liú xíng',
  留空: 'liú kòng',
  留难: 'liú nàn',
  留种: 'liú zhǒng',
  榴弹: 'liú dàn',
  馏分: 'liú fèn',
  柳荫: 'liǔ yīn',
  六朝: 'liù cháo',
  咯噔: 'gē dēng',
  咯咯: 'gē gē',
  咯血: 'kǎ xiě',
  咯吱: 'gē zhī',
  龙卷: 'lóng juǎn',
  露白: 'lòu bái',
  露丑: 'lòu chǒu',
  露底: 'lòu dǐ',
  露风: 'lòu fēng',
  露富: 'lòu fù',
  露骨: 'lòu gǔ',
  露脸: 'lòu liǎn',
  露面: 'lòu miàn',
  露苗: 'lòu miáo',
  露怯: 'lòu qiè',
  露馅: 'lòu xiàn',
  露相: 'lòu xiàng',
  碌碡: 'liù zhou',
  路卡: 'lù qiǎ',
  履行: 'lǚ xíng',
  旅行: 'lǚ xíng',
  率领: 'shuài lǐng',
  率然: 'shuài rán',
  率性: 'shuài xìng',
  率真: 'shuài zhēn',
  率直: 'shuài zhí',
  沦没: 'lún mò',
  纶巾: 'guān jīn',
  轮转: 'lún zhuàn',
  论处: 'lùn chǔ',
  论调: 'lùn diào',
  论难: 'lùn nàn',
  论语: 'lún yǔ',
  螺杆: 'luó gǎn',
  络子: 'lào zi',
  落泊: 'luò bó',
  落得: 'luò de',
  落发: 'luò fà',
  落价: 'lào jià',
  落难: 'luò nàn',
  落魄: 'luò tuò',
  落下: 'là xià',
  落枕: 'lào zhěn',
  落子: 'lào zǐ',
  漯河: 'luò tà hé',
  马圈: 'mǎ juàn',
  马尾: 'mǎ yǐ',
  马扎: 'mǎ zhá',
  码垛: 'mǎ duǒ',
  蚂螂: 'mā láng',
  蚂蚱: 'mà zhà',
  唛头: 'mà tóu',
  吗啡: 'mǎ fēi',
  埋没: 'mái mò',
  埋怨: 'mán yuàn',
  卖相: 'mài xiàng',
  脉脉: 'mò mò',
  蛮干: 'mán gàn',
  蛮横: 'mán hèng',
  馒头: 'mán tou',
  满处: 'mǎn chǔ',
  满载: 'mǎn zài',
  蟒袍: 'mǎng páo',
  蟒蛇: 'mǎng shé',
  毛发: 'máo fà',
  毛呢: 'máo ní',
  锚泊: 'máo bó',
  没齿: 'mò chǐ',
  没空: 'méi kòng',
  没落: 'mò luò',
  没入: 'mò rù',
  没世: 'mò shì',
  没收: 'mò shōu',
  没药: 'mò yào',
  美差: 'měi chāi',
  门把: 'mén bà',
  闷酒: 'mèn jiǔ',
  闷棍: 'mèn gùn',
  闷倦: 'mèn juàn',
  闷头: 'mèn tóu',
  蒙尘: 'meng chen',
  蒙难: 'méng nàn',
  蒙事: 'mēng shì',
  弥缝: 'mí féng',
  迷糊: 'mí hu',
  靡丽: 'mǐ lì',
  糜子: 'méi zǐ',
  泌阳: 'bì yáng',
  秘鲁: 'bì lǔ',
  免得: 'miǎn de',
  勉强: 'miǎn qiǎng',
  面朝: 'miàn cháo',
  面糊: 'miàn hù',
  灭种: 'miè zhǒng',
  民乐: 'mín yuè',
  泯没: 'mǐn mò',
  名簿: 'míng bù',
  名将: 'míng jiàng',
  名角: 'míng jué',
  名刹: 'míng shā',
  明朝: 'míng cháo',
  明了: 'míng liǎo',
  命薄: 'mìng bó',
  命中: 'mìng zhòng',
  谬种: 'miù zhǒng',
  模板: 'mú bǎn',
  模糊: 'mó hu',
  模具: 'mú jù',
  模样: 'mú yàng',
  模子: 'mú zǐ',
  摩挲: 'mā sā',
  磨叨: 'mò dāo',
  磨烦: 'mò fán',
  磨坊: 'mò fáng',
  磨难: 'mó nàn',
  磨盘: 'mò pán',
  磨子: 'mò zǐ',
  魔爪: 'mó zhǎo',
  抹布: 'mā bù',
  抹灰: 'mò huī',
  抹脸: 'mā liǎn',
  抹胸: 'mò xiōng',
  末了: 'mò liǎo',
  牟利: 'móu lì',
  牟取: 'móu qǔ',
  木杆: 'mù gǎn',
  木模: 'mù mú',
  木头: 'mù tou',
  木栅: 'mù shān',
  目的: 'mù dì',
  墓碣: 'mù jié',
  哪个: 'něi gè',
  哪些: 'něi xiē',
  哪吒: 'né zhā',
  内传: 'nèi zhuàn',
  内省: 'nèi xǐng',
  那些: 'nèi xiē',
  纳降: 'nà xiáng',
  纳闷: 'nà mèn',
  南朝: 'nán cháo',
  难胞: 'nàn bāo',
  难处: 'nán chǔ',
  难倒: 'nán dǎo',
  难得: 'nán de',
  难民: 'nàn mín',
  难侨: 'nàn qiáo',
  难为: 'nán wéi',
  难友: 'nàn yǒu',
  难属: 'nàn shǔ',
  孬种: 'nāo zhǒng',
  闹哄: 'nào hōng',
  闹嚷: 'nào rāng',
  呢喃: 'ní nán',
  呢绒: 'ní róng',
  呢子: 'ní zǐ',
  能干: 'néng gàn',
  能量: 'néng liàng',
  泥古: 'nì gǔ',
  泥淖: 'ní nào',
  泥子: 'nì zǐ',
  霓裳: 'ní cháng',
  逆行: 'nì xíng',
  年长: 'nián zhǎng',
  年假: 'nián jià',
  年少: 'nián shào',
  碾坊: 'niǎn fáng',
  念头: 'niàn tou',
  袅娜: 'niǎo nuó',
  尿脬: 'suī pāo',
  尿泡: 'suī pào',
  尿血: 'niào xuè',
  孽种: 'niè zhǒng',
  宁可: 'nìng kě',
  宁肯: 'nìng kěn',
  宁帖: 'níng tiē',
  宁愿: 'nìng yuàn',
  浓荫: 'nóng yīn',
  脓血: 'nóng xuè',
  弄口: 'lòng kǒu',
  弄堂: 'lòng táng',
  怒号: 'nù háo',
  怒喝: 'nù hè',
  女红: 'nǚ gōng',
  女将: 'nǚ jiàng',
  疟子: 'yào zǐ',
  暖和: 'nuǎn huo',
  殴斗: 'ōu dòu',
  呕血: 'ǒu xuè',
  呕哑: 'ōu yā',
  啪嗒: 'pā dā',
  爬行: 'pá xíng',
  耙地: 'bà dì',
  排长: 'pái zhǎng',
  排场: 'pái chang',
  判处: 'pàn chǔ',
  盼头: 'pàn tou',
  刨冰: 'bào bīng',
  刨床: 'bào chuáng',
  刨刀: 'bào dāo',
  刨削: 'páo xuē',
  刨子: 'bào zǐ',
  炮弹: 'pào dàn',
  炮烙: 'páo luò',
  炮制: 'páo zhì',
  跑调: 'pǎo diào',
  泡货: 'pāo huò',
  泡桐: 'pāo tóng',
  泡子: 'pāo zǐ',
  赔还: 'péi huán',
  配称: 'pèi chèn',
  配调: 'pèi diào',
  配给: 'pèi jǐ',
  配角: 'pèi jué',
  配乐: 'pèi yuè',
  配曲: 'pèi qǔ',
  配种: 'pèi zhǒng',
  喷薄: 'pēn bó',
  喷撒: 'pēn sǎ',
  喷吐: 'pēn tǔ',
  喷香: 'pèn xiāng',
  棚圈: 'péng juàn',
  批斗: 'pī dòu',
  批假: 'pī jià',
  批量: 'pī liàng',
  披发: 'pī fà',
  纰缪: 'pī miù',
  纰漏: 'pī lòu',
  披散: 'pī sǎn',
  劈柴: 'pǐ chái',
  劈叉: 'pǐ chà',
  劈成: 'pǐ chéng',
  皮夹: 'pí jiā',
  皮相: 'pí xiàng',
  疲沓: 'pí ta',
  癖好: 'pǐ hào',
  睥睨: 'bì nì',
  片儿: 'piān er',
  片头: 'piān tóu',
  片子: 'piān zi',
  偏差: 'piān chā',
  篇什: 'piān shí',
  漂泊: 'piāo bó',
  漂白: 'piǎo bái',
  漂亮: 'piào liàng',
  漂染: 'piǎo rǎn',
  漂洗: 'piǎo xǐ',
  缥缈: 'piāo miǎo',
  飘泊: 'piāo bó',
  撇开: 'piē kāi',
  撇弃: 'piē qì',
  姘头: 'pīn tou',
  拼斗: 'pīn dòu',
  贫血: 'pín xuè',
  嫔妃: 'pín fēi',
  频数: 'pín shuò',
  品行: 'pǐn xíng',
  品种: 'pǐn zhǒng',
  平调: 'píng diào',
  平峒: 'píng dòng',
  平巷: 'píng hàng',
  平行: 'píng xíng',
  评传: 'píng zhuàn',
  评量: 'píng liàng',
  苹果: 'pín guǒ',
  屏除: 'bǐng chú',
  屏气: 'bǐng qì',
  屏弃: 'bǐng qì',
  屏退: 'bǐng tuì',
  屏息: 'bǐng xī',
  破相: 'pò xiàng',
  扑棱: 'pū lēng',
  扑扇: 'pū shān',
  铺陈: 'pū chén',
  铺衬: 'pū chèn',
  铺床: 'pū chuáng',
  铺垫: 'pū diàn',
  铺盖: 'pū gài',
  铺轨: 'pū guǐ',
  铺路: 'pū lù',
  铺面: 'pū miàn',
  铺排: 'pū pái',
  铺平: 'pū píng',
  铺砌: 'pū qì',
  铺设: 'pū shè',
  铺叙: 'pū xù',
  铺展: 'pū zhǎn',
  铺张: 'pū zhāng',
  朴硝: 'pò xiāo',
  普查: 'pǔ zhā',
  谱曲: 'pǔ qǔ',
  曝光: 'bào guāng',
  期年: 'jī nián',
  齐明: 'zī míng',
  齐行: 'qí xíng',
  奇零: 'jī líng',
  奇偶: 'jī ǒu',
  奇数: 'jī shù',
  耆老: 'qí lǎo',
  耆宿: 'qí sù',
  乞降: 'qǐ xiáng',
  企划: 'qǐ huá',
  启行: 'qǐ xíng',
  起哄: 'qǐ hòng',
  起解: 'qǐ jiè',
  起兴: 'qǐ xìng',
  起行: 'qǐ xíng',
  气量: 'qì liàng',
  气闷: 'qì mèn',
  气血: 'qì xuè',
  泣血: 'qì xuè',
  器量: 'qì liàng',
  恰当: 'qià dàng',
  恰切: 'qià qiē',
  牵累: 'qiān lěi',
  牵强: 'qiān qiǎng',
  铅弹: 'qiān dàn',
  铅山: 'yán shān',
  前朝: 'qián cháo',
  前头: 'qián tou',
  前行: 'qián xíng',
  钱夹: 'qián jiā',
  潜行: 'qián xíng',
  浅薄: 'qiǎn bó',
  浅浅: 'jiān jiān',
  戗风: 'qiāng fēng',
  枪杆: 'qiāng gǎn',
  枪弹: 'qiāng dàn',
  腔调: 'qiāng diào',
  强逼: 'qiǎng bī',
  强调: 'qiáng diào',
  强干: 'qiáng gàn',
  强横: 'qiáng hèng',
  强将: 'qiáng jiàng',
  强劲: 'qiáng jìng',
  强留: 'qiǎng liú',
  强迫: 'qiǎng pò',
  强求: 'qiǎng qiú',
  强人: 'qiǎng rén',
  强笑: 'qiǎng xiào',
  强行: 'qiáng xíng',
  强颜: 'qiǎng yán',
  强嘴: 'jiàng zuǐ',
  墙垛: 'qiáng duǒ',
  悄然: 'qiǎo rán',
  悄声: 'qiǎo shēng',
  巧干: 'qiǎo gàn',
  俏头: 'qiào tou',
  翘楚: 'qiáo chǔ',
  翘棱: 'qiáo lēng',
  翘盼: 'qiáo pàn',
  翘企: 'qiáo qǐ',
  翘首: 'qiáo shǒu',
  翘望: 'qiáo wàng',
  切变: 'qiē biàn',
  切除: 'qiē chú',
  切磋: 'qiē cuō',
  切当: 'qiē dāng',
  切点: 'qiē diǎn',
  切断: 'qiē duàn',
  切糕: 'qiē gāo',
  切割: 'qiē gē',
  切花: 'qiē huā',
  切结: 'qiē jié',
  切口: 'qiē kǒu',
  切面: 'qiē miàn',
  切片: 'qiē piàn',
  切切: 'qiē qiē',
  切入: 'qiē rù',
  切勿: 'qiē wù',
  切屑: 'qiē xiè',
  切削: 'qiē xiāo',
  切中: 'qiè zhòng',
  亲家: 'qìng jia',
  钦差: 'qīn chāi',
  秦艽: 'qín jiāo',
  琴曲: 'qín qǔ',
  勤朴: 'qín piáo',
  氢弹: 'qīng dàn',
  轻薄: 'qīng bó',
  轻率: 'qīng shuài',
  倾倒: 'qīng dǎo',
  倾吐: 'qīng tǔ',
  请调: 'qǐng diào',
  请假: 'qǐng jià',
  请降: 'qǐng xiáng',
  秋种: 'qiū zhǒng',
  求降: 'qiú xiáng',
  酋长: 'qiú zhǎng',
  遒劲: 'qiú jìng',
  曲池: 'qǔ chí',
  曲调: 'qǔ diào',
  曲度: 'qǔ dù',
  曲江: 'qǔ jiāng',
  曲剧: 'qǔ jù',
  曲率: 'qǔ lǜ',
  曲面: 'qǔ miàn',
  曲目: 'qǔ mù',
  曲牌: 'qǔ pái',
  曲谱: 'qǔ pǔ',
  曲泉: 'qǔ quán',
  曲蟮: 'qǔ shàn',
  曲水: 'qǔ shuǐ',
  曲艺: 'qǔ yì',
  曲张: 'qǔ zhāng',
  曲泽: 'qǔ zé',
  曲子: 'qǔ zi',
  屈曲: 'qū qǔ',
  屈折: 'qū shé',
  躯干: 'qū gàn',
  躯壳: 'qū qiào',
  取得: 'qǔ de',
  圈子: 'quān zi',
  全都: 'quán dōu',
  拳头: 'quán tou',
  鬈曲: 'quán qǔ',
  劝降: 'quàn xiáng',
  雀子: 'qiāo zǐ',
  确当: 'què dàng',
  阙如: 'quē rú',
  阙漏: 'quē lòu',
  阙文: 'quē wén',
  阙疑: 'quē yí',
  群氓: 'qún méng',
  染坊: 'rǎn fáng',
  嚷嚷: 'rāng rang',
  绕行: 'rào xíng',
  热和: 'rè huo',
  热量: 'rè liàng',
  热血: 'rè xuè',
  人参: 'rén shēn',
  人为: 'rén wéi',
  人种: 'rén zhǒng',
  认得: 'rèn de',
  认识: 'rèn shi',
  认为: 'rèn wéi',
  恁地: 'nèn dì',
  日头: 'rì tou',
  日晕: 'rì yùn',
  容量: 'róng liàng',
  溶斗: 'róng dòu',
  溶血: 'róng xuè',
  儒将: 'rú jiàng',
  蠕行: 'rú xíng',
  乳臭: 'rǔ xiù',
  辱没: 'rǔ mò',
  入行: 'rù xíng',
  软和: 'ruǎn huo',
  若夫: 'ruò fú',
  弱冠: 'ruò guàn',
  撒播: 'sǎ bō',
  撒布: 'sǎ bù',
  撒施: 'sǎ shī',
  塞北: 'sài běi',
  塞门: 'sài mén',
  塞外: 'sài wài',
  塞音: 'sè yīn',
  塞责: 'sè zé',
  塞子: 'sāi zi',
  三藏: 'sān zàng',
  三更: 'sān gēng',
  三行: 'sān xíng',
  三重: 'sān chóng',
  散兵: 'sǎn bīng',
  散板: 'sǎn bǎn',
  散发: 'sàn fà',
  散工: 'sǎn gōng',
  散光: 'sǎn guāng',
  散记: 'sǎn jì',
  散剂: 'sǎn jì',
  散架: 'sǎn jià',
  散见: 'sǎn jiàn',
  散件: 'sǎn jiàn',
  散居: 'sǎn jū',
  散乱: 'sǎn luàn',
  散漫: 'sǎn màn',
  散闷: 'sàn mèn',
  散曲: 'sǎn qǔ',
  散沙: 'sǎn shā',
  散射: 'sǎn shè',
  散碎: 'sǎn suì',
  散体: 'sǎn tǐ',
  散文: 'sǎn wén',
  散装: 'sǎn zhuāng',
  桑椹: 'sāng shèn',
  丧服: 'sāng fú',
  丧假: 'sāng jià',
  丧礼: 'sāng lǐ',
  丧乱: 'sāng luàn',
  丧事: 'sāng shì',
  丧葬: 'sāng zàng',
  丧钟: 'sāng zhōng',
  扫把: 'sào bǎ',
  扫兴: 'sǎo xìng',
  扫帚: 'sào zhǒu',
  色调: 'sè diào',
  色相: 'sè xiàng',
  色晕: 'sè yùn',
  沙参: 'shā shēn',
  沙拉: 'shā là',
  沙子: 'shā zi',
  刹把: 'shā bǎ',
  刹车: 'shā chē',
  刹刹: 'shā shā',
  刹时: 'shā shí',
  莎草: 'suō cǎo',
  刹住: 'shā zhù',
  歃血: 'shà xuè',
  煞笔: 'shā bǐ',
  煞车: 'shā chē',
  煞尾: 'shā wěi',
  煞住: 'shā zhù',
  晒场: 'shài cháng',
  删削: 'shān xuē',
  姗姗: 'shān shān',
  膻中: 'dàn zhōng',
  苫布: 'shàn bù',
  苫盖: 'shàn gài',
  扇动: 'shān dòng',
  扇惑: 'shān huò',
  扇子: 'shàn zi',
  善处: 'shàn chǔ',
  善行: 'shàn xíng',
  商调: 'shāng diào',
  上朝: 'shàng cháo',
  上当: 'shàng dàng',
  上调: 'shàng diào',
  上将: 'shàng jiàng',
  上卷: 'shàng juǎn',
  上去: 'shǎng qù',
  上声: 'shǎng shēng',
  上头: 'shàng tou',
  上相: 'shàng xiàng',
  上行: 'shàng xíng',
  稍为: 'shāo wéi',
  稍息: 'shào xī',
  少府: 'shào fǔ',
  少妇: 'shào fù',
  少将: 'shào jiàng',
  少量: 'shǎo liàng',
  少年: 'shào nián',
  少女: 'shào nǚ',
  少尉: 'shào wèi',
  少相: 'shào xiāng',
  少小: 'shào xiǎo',
  少校: 'shào xiào',
  少爷: 'shào yé',
  少壮: 'shào zhuàng',
  哨卡: 'shào qiǎ',
  舌苔: 'shé tāi',
  舌头: 'shé tou',
  蛇行: 'shé xíng',
  舍得: 'shè de',
  射干: 'yè gàn',
  申曲: 'shēn qǔ',
  身分: 'shēn fèn',
  身量: 'shēn liàng',
  深省: 'shēn xǐng',
  神祇: 'shén qí',
  神阙: 'shén quē',
  审查: 'shěn zhā',
  审处: 'shěn chǔ',
  审度: 'shěn duó',
  审干: 'shěn gàn',
  审校: 'shěn jiào',
  甚为: 'shèn wéi',
  慎行: 'shèn xíng',
  生长: 'shēng zhǎng',
  生发: 'shēng fà',
  生还: 'shēng huán',
  生角: 'shēng jué',
  生肖: 'shēng xiào',
  声调: 'shēng diào',
  声乐: 'shēng yuè',
  胜朝: 'shèng cháo',
  渑池: 'miǎn chí',
  省察: 'xǐng chá',
  省得: 'shěng de',
  省亲: 'xǐng qīn',
  省视: 'xǐng shì',
  省悟: 'xǐng wù',
  失当: 'shī dàng',
  失血: 'shī xuè',
  失着: 'shī zhāo',
  师长: 'shī zhǎng',
  师父: 'shī fu',
  诗兴: 'shī xìng',
  施为: 'shī wéi',
  施行: 'shī xíng',
  什锦: 'shí jǐn',
  什物: 'shí wù',
  石头: 'shí tou',
  时调: 'shí diào',
  识记: 'zhì jì',
  识相: 'shí xiàng',
  实弹: 'shí dàn',
  实干: 'shí gàn',
  实相: 'shí xiàng',
  实行: 'shí xíng',
  拾掇: 'shí duo',
  食量: 'shí liàng',
  莳萝: 'shí luó',
  矢量: 'shǐ liàng',
  使得: 'shǐ de',
  市长: 'shì zhǎng',
  事假: 'shì jià',
  试行: 'shì xíng',
  适当: 'shì dàng',
  适量: 'shì liàng',
  嗜好: 'shì hào',
  嗜血: 'shì xuè',
  螫针: 'shì zhēn',
  手夹: 'shǒu jiā',
  手相: 'shǒu xiàng',
  手爪: 'shǒu zhǎo',
  守分: 'shǒu fèn',
  守丧: 'shǒu sāng',
  首长: 'shǒu zhǎng',
  首相: 'shǒu xiàng',
  受降: 'shòu xiáng',
  受累: 'shòu lěi',
  受难: 'shòu nàn',
  瘦削: 'shòu xuē',
  书僮: 'shū tóng',
  疏浚: 'shū jùn',
  输血: 'shū xuè',
  赎当: 'shú dàng',
  暑假: 'shǔ jià',
  束发: 'shù fà',
  树干: 'shù gàn',
  树杈: 'shù chà',
  树荫: 'shù yīn',
  树种: 'shù zhǒng',
  数九: 'shǔ jiǔ',
  数量: 'shù liàng',
  数落: 'shǔ luò',
  数数: 'shuò shuò',
  数说: 'shǔ shuō',
  刷白: 'shuà bái',
  耍横: 'shuǎ hèng',
  摔倒: 'shuāi dǎo',
  摔打: 'shuāi dá',
  栓塞: 'shuān sè',
  双重: 'shuāng chóng',
  水斗: 'shuǐ dòu',
  水分: 'shuǐ fèn',
  水浒: 'shuǐ hǔ',
  水量: 'shuǐ liàng',
  水栅: 'shuǐ shān',
  税卡: 'shuì qiǎ',
  税种: 'shuì zhǒng',
  睡觉: 'shuì jiào',
  睡相: 'shuì xiàng',
  顺差: 'shùn chā',
  说项: 'shuì xiàng',
  私处: 'sī chǔ',
  私斗: 'sī dòu',
  思量: 'sī liang',
  死当: 'sǐ dàng',
  死难: 'sǐ nàn',
  寺观: 'sì guàn',
  伺候: 'cì hou',
  似的: 'shì de',
  肆行: 'sì xíng',
  松散: 'sōng sǎn',
  宋朝: 'sòng cháo',
  送行: 'sòng xíng',
  搜查: 'sōu zhā',
  搜括: 'sōu guā',
  苏打: 'sū dá',
  俗曲: 'sú qǔ',
  素朴: 'sù piáo',
  宿将: 'sù jiàng',
  算得: 'suàn de',
  遂行: 'suì xíng',
  孙子: 'sūn zi',
  所得: 'suǒ de',
  锁钥: 'suǒ yuè',
  他处: 'tā chǔ',
  胎发: 'tāi fà',
  台子: 'tái zi',
  太冲: 'tài chòng',
  太监: 'tài jiàn',
  谈兴: 'tán xìng',
  谈吐: 'tán tǔ',
  坦率: 'tǎn shuài',
  棠棣: 'táng dì',
  搪塞: 'táng sè',
  糖弹: 'táng dàn',
  倘佯: 'cháng yáng',
  耥耙: 'tǎng bà',
  躺倒: 'tǎng dǎo',
  烫发: 'tàng fà',
  逃奔: 'táo bèn',
  逃难: 'táo nàn',
  讨还: 'tǎo huán',
  套曲: 'tào qǔ',
  特种: 'tè zhǒng',
  藤蔓: 'téng wàn',
  啼血: 'tí xuè',
  提调: 'tí diào',
  提防: 'dī fáng',
  提干: 'tí gàn',
  提供: 'tí gōng',
  提溜: 'dī liū',
  醍醐: 'tí hú',
  体己: 'tī ji',
  体量: 'tǐ liàng',
  剃发: 'tì fà',
  嚏喷: 'tì pen',
  天朝: 'tiān cháo',
  天分: 'tiān fèn',
  天台: 'tiān tāi',
  天呀: 'tiān yā',
  田父: 'tián fǔ',
  填空: 'tián kòng',
  佻薄: 'tiāo bó',
  挑拨: 'tiǎo bō',
  挑担: 'tiāo dàn',
  挑灯: 'tiǎo dēng',
  挑动: 'tiǎo dòng',
  挑逗: 'tiǎo dòu',
  挑花: 'tiǎo huā',
  挑明: 'tiǎo míng',
  挑弄: 'tiǎo nòng',
  挑唆: 'tiǎo suō',
  挑衅: 'tiǎo xìn',
  挑中: 'tiāo zhòng',
  挑战: 'tiǎo zhàn',
  挑子: 'tiāo zi',
  挑嘴: 'tiǎo zuǐ',
  条畅: 'dí dàng',
  条干: 'tiáo gàn',
  条几: 'tiáo jī',
  条子: 'tiáo zi',
  跳踉: 'tiào liáng',
  铁杆: 'tiě gǎn',
  铁血: 'tiě xuè',
  铁椎: 'tiě chuí',
  帖服: 'tiē fú',
  听差: 'tīng chāi',
  庭长: 'tíng zhǎng',
  挺括: 'tǐng guā',
  通红: 'tòng hóng',
  通缉: 'tōng jī',
  通量: 'tōng liàng',
  通行: 'tōng xíng',
  同调: 'tóng diào',
  同好: 'tóng hào',
  同量: 'tóng liàng',
  同种: 'tóng zhǒng',
  僮仆: 'tóng pú',
  统率: 'tǒng shuài',
  痛恶: 'tòng wù',
  偷空: 'tōu kòng',
  头儿: 'tou er',
  头发: 'tóu fà',
  头子: 'tóu zi',
  投奔: 'tóu bèn',
  投弹: 'tóu dàn',
  投降: 'tóu xiáng',
  徒长: 'tú zhǎng',
  土堡: 'tǔ pù',
  土种: 'tǔ zhǒng',
  吐蕃: 'tǔ bō',
  吐口: 'tǔ kǒu',
  吐露: 'tǔ lù',
  吐气: 'tǔ qì',
  吐弃: 'tǔ qì',
  吐穗: 'tǔ suì',
  吐絮: 'tǔ xù',
  吐艳: 'tǔ yàn',
  吐属: 'tǔ shǔ',
  吐字: 'tǔ zì',
  团长: 'tuán zhǎng',
  退朝: 'tuì cháo',
  退还: 'tuì huán',
  退行: 'tuì xíng',
  褪去: 'tùn qù',
  褪色: 'tuì shǎi',
  吞没: 'tūn mò',
  吞吐: 'tūn tǔ',
  吞咽: 'tūn yàn',
  拖累: 'tuō lěi',
  妥当: 'tuǒ dàng',
  妥帖: 'tuǒ tiē',
  拓本: 'tà běn',
  拓片: 'tà piàn',
  拓印: 'tà yìn',
  哇啦: 'wā lā',
  瓦刀: 'wà dāo',
  外长: 'wài zhǎng',
  外传: 'wài zhuàn',
  外调: 'wài diào',
  外强: 'wài jiāng',
  外切: 'wài qiē',
  外头: 'wài tou',
  湾泊: 'wān bó',
  玩兴: 'wán xìng',
  王朝: 'wáng cháo',
  王妃: 'wáng fēi',
  往还: 'wǎng huán',
  妄为: 'wàng wéi',
  危难: 'wēi nàn',
  威吓: 'wēi hè',
  逶迤: 'wēi yí',
  微薄: 'wēi bó',
  微行: 'wēi xíng',
  为害: 'wéi hài',
  为患: 'wéi huàn',
  为难: 'wéi nán',
  为期: 'wéi qī',
  为人: 'wéi rén',
  为生: 'wéi shēng',
  为时: 'wéi shí',
  为首: 'wéi shǒu',
  为数: 'wéi shù',
  为伍: 'wéi wǔ',
  为限: 'wéi xiàn',
  为政: 'wéi zhèng',
  为止: 'wéi zhǐ',
  为主: 'wéi zhǔ',
  为着: 'wéi zhe',
  圩堤: 'wéi dī',
  圩垸: 'wéi yuàn',
  圩子: 'wéi zǐ',
  委靡: 'wěi mǐ',
  委蛇: 'wēi yí',
  未了: 'wèi liǎo',
  未曾: 'wèi zēng',
  魏阙: 'wèi quē',
  文斗: 'wén dòu',
  文蛤: 'wén gé',
  问难: 'wèn nàn',
  莴苣: 'wō jù',
  喔唷: 'ō yō',
  窝囊: 'wō nāng',
  卧倒: 'wò dǎo',
  乌拉: 'wù la',
  无处: 'wú chǔ',
  无间: 'wú jiàn',
  无量: 'wú liàng',
  无宁: 'wú nìng',
  无为: 'wú wéi',
  无行: 'wú xíng',
  无着: 'wú zhuó',
  毋宁: 'wú nìng',
  吾辈: 'wú bèi',
  吾侪: 'wú chái',
  吾人: 'wú rén',
  吾子: 'wú zǐ',
  五更: 'wǔ gēng',
  五行: 'wǔ xíng',
  午觉: 'wǔ jiào',
  武斗: 'wǔ dòu',
  武将: 'wǔ jiàng',
  武行: 'wǔ xíng',
  舞曲: 'wǔ qǔ',
  物种: 'wù zhǒng',
  误差: 'wù chā',
  西藏: 'xī zàng',
  西乐: 'xī yuè',
  吸着: 'xī zhuó',
  稀薄: 'xī bó',
  膝行: 'xī xíng',
  席卷: 'xí juǎn',
  喜好: 'xǐ hào',
  喜兴: 'xǐ xìng',
  戏曲: 'xì qǔ',
  系泊: 'jì bó',
  系带: 'jì dài',
  系绳: 'jì shéng',
  细发: 'xì fà',
  细挑: 'xì tāo',
  虾蟆: 'há má',
  下乘: 'xià shèng',
  下处: 'xià chǔ',
  下调: 'xià diào',
  下头: 'xià tou',
  下行: 'xià xíng',
  下咽: 'xià yàn',
  下种: 'xià zhǒng',
  吓唬: 'xià hu',
  先行: 'xiān xíng',
  纤夫: 'qiàn fū',
  纤手: 'qiàn shǒu',
  纤绳: 'qiàn shéng',
  鲜血: 'xiān xuè',
  闲空: 'xián kòng',
  闲散: 'xián sǎn',
  弦乐: 'xián yuè',
  嫌恶: 'xián wù',
  显得: 'xiǎn de',
  县长: 'xiàn zhǎng',
  现量: 'xiàn liàng',
  现行: 'xiàn xíng',
  限量: 'xiàn liàng',
  献血: 'xiàn xuè',
  霰弹: 'xiàn dàn',
  相册: 'xiàng cè',
  相称: 'xiāng chèn',
  相处: 'xiāng chǔ',
  相得: 'xiāng de',
  相公: 'xiàng gōng',
  相国: 'xiàng guó',
  相机: 'xiàng jī',
  相间: 'xiāng jiàn',
  相角: 'xiàng jiǎo',
  相率: 'xiāng shuài',
  相马: 'xiàng mǎ',
  相貌: 'xiàng mào',
  相面: 'xiàng miàn',
  相片: 'xiàng piān',
  相扑: 'xiàng pū',
  相声: 'xiàng sheng',
  相士: 'xiàng shì',
  相图: 'xiàng tú',
  相位: 'xiàng wèi',
  相纸: 'xiàng zhǐ',
  相中: 'xiāng zhòng',
  香槟: 'xiāng bīn',
  箱笼: 'xiāng lǒng',
  想头: 'xiǎng tou',
  巷道: 'hàng dào',
  巷子: 'xiàng zi',
  削壁: 'xuē bì',
  削除: 'xuē chú',
  削发: 'xuē fà',
  削价: 'xuē jià',
  削肩: 'xuē jiān',
  削减: 'xuē jiǎn',
  削平: 'xuē píng',
  削弱: 'xuē ruò',
  削职: 'xuē zhí',
  削瘦: 'xuē shòu',
  削削: 'xuē xuē',
  骁将: 'xiāo jiàng',
  宵旰: 'xiāo gàn',
  消长: 'xiāo zhǎng',
  销假: 'xiāo jià',
  销量: 'xiāo liàng',
  销行: 'xiāo xíng',
  小传: 'xiǎo zhuàn',
  小调: 'xiǎo diào',
  小将: 'xiǎo jiàng',
  小量: 'xiǎo liàng',
  小曲: 'xiǎo qǔ',
  晓得: 'xiǎo de',
  孝行: 'xiào xíng',
  肖像: 'xiào xiàng',
  校场: 'jiào chǎng',
  校长: 'xiào zhǎng',
  校点: 'jiào diǎn',
  校订: 'jiào dìng',
  校对: 'jiào duì',
  校改: 'jiào gǎi',
  校核: 'jiào hé',
  校勘: 'jiào kān',
  校验: 'jiào yàn',
  校样: 'jiào yàng',
  校阅: 'jiào yuè',
  校正: 'jiào zhèng',
  校注: 'jiào zhù',
  校准: 'jiào zhǔn',
  邪行: 'xié xíng',
  偕行: 'xié xíng',
  泄露: 'xiè lòu',
  心曲: 'xīn qǔ',
  心血: 'xīn xuè',
  芯子: 'xìn zǐ',
  莘莘: 'shēn shēn',
  新正: 'xīn zhēng',
  信差: 'xìn chāi',
  兴会: 'xìng huì',
  兴趣: 'xìng qù',
  兴头: 'xìng tou',
  兴味: 'xìng wèi',
  兴致: 'xìng zhì',
  星宿: 'xīng xiù',
  星相: 'xīng xiàng',
  星占: 'xīng zhān',
  惺忪: 'xīng sōng',
  腥臊: 'xīng sāo',
  刑种: 'xíng zhǒng',
  行板: 'xíng bǎn',
  行笔: 'xíng bǐ',
  行草: 'xíng cǎo',
  行藏: 'xíng cáng',
  行车: 'xíng chē',
  行船: 'xíng chuán',
  行程: 'xíng chéng',
  行刺: 'xíng cì',
  行都: 'xíng dū',
  行动: 'xíng dòng',
  行东: 'xíng dōng',
  行房: 'xíng fáng',
  行贩: 'xíng fàn',
  行风: 'xíng fēng',
  行宫: 'xíng gōng',
  行好: 'xíng hǎo',
  行号: 'háng háo',
  行贿: 'xíng huì',
  行迹: 'xíng jì',
  行贾: 'xíng gǔ',
  行将: 'xíng jiāng',
  行脚: 'xíng jiǎo',
  行劫: 'xíng jié',
  行进: 'xíng jìn',
  行径: 'xíng jìng',
  行经: 'xíng jīng',
  行军: 'xíng jūn',
  行楷: 'xíng kǎi',
  行款: 'xíng kuǎn',
  行乐: 'xíng lè',
  行李: 'xíng lǐ',
  行礼: 'xíng lǐ',
  行猎: 'xíng liè',
  行令: 'xíng lìng',
  行路: 'xíng lù',
  行旅: 'xíng lǚ',
  行囊: 'xíng náng',
  行年: 'xíng nián',
  行聘: 'xíng pìn',
  行骗: 'xíng piàn',
  行期: 'xíng qī',
  行乞: 'xíng qǐ',
  行抢: 'xíng qiǎng',
  行腔: 'xíng qiāng',
  行窃: 'xíng qiè',
  行箧: 'xíng qiè',
  行人: 'xíng rén',
  行色: 'xíng sè',
  行善: 'xíng shàn',
  行赏: 'xíng shǎng',
  行省: 'xíng shěng',
  行时: 'xíng shí',
  行使: 'xíng shǐ',
  行驶: 'xíng shǐ',
  行事: 'xíng shì',
  行书: 'xíng shū',
  行署: 'xíng shǔ',
  行述: 'xíng shù',
  行唐: 'xíng táng',
  行头: 'xíng tou',
  行为: 'xíng wéi',
  行文: 'xíng wén',
  行销: 'xíng xiāo',
  行星: 'xíng xīng',
  行刑: 'xíng xíng',
  行行: 'xíng xíng',
  行凶: 'xíng xiōng',
  行医: 'xíng yī',
  行营: 'xíng yíng',
  行吟: 'xíng yín',
  行辕: 'xíng yuán',
  行运: 'xíng yùn',
  行灶: 'xíng zào',
  行诈: 'xíng zhà',
  行栈: 'xíng zhàn',
  行者: 'xíng zhě',
  行政: 'xíng zhèng',
  行止: 'xíng zhǐ',
  行装: 'xíng zhuāng',
  行舟: 'xíng zhōu',
  行状: 'xíng zhuàng',
  行走: 'xíng zǒu',
  行踪: 'xíng zōng',
  幸得: 'xìng de',
  性行: 'xìng xíng',
  凶横: 'xiōng hèng',
  兄长: 'xiōng zhǎng',
  凶相: 'xiōng xiàng',
  雄劲: 'xióng jìng',
  休假: 'xiū jià',
  修行: 'xiū xíng',
  羞恶: 'xiū wù',
  须发: 'xū fà',
  序曲: 'xù qǔ',
  畜产: 'xù chǎn',
  畜牧: 'xù mù',
  畜圈: 'chù juàn',
  畜养: 'xù yǎng',
  絮叨: 'xù dáo',
  选调: 'xuǎn diào',
  选曲: 'xuǎn qǔ',
  选种: 'xuǎn zhǒng',
  学长: 'xué zhǎng',
  血癌: 'xuè ái',
  血案: 'xuè àn',
  血本: 'xuè běn',
  血崩: 'xuè bēng',
  血泊: 'xuè pō',
  血沉: 'xuè chén',
  血仇: 'xuè chóu',
  血防: 'xuè fáng',
  血汗: 'xuè hàn',
  血海: 'xuè hǎi',
  血管: 'xuè guǎn',
  血痕: 'xuè hén',
  血红: 'xuè hóng',
  血花: 'xuè huā',
  血祭: 'xuè jì',
  血迹: 'xuè jì',
  血浆: 'xuè jiāng',
  血竭: 'xuè jié',
  血口: 'xuè kǒu',
  血亏: 'xuè kuī',
  血泪: 'xuè lèi',
  血块: 'xuè kuài',
  血库: 'xuè kù',
  血流: 'xuè liú',
  血路: 'xuè lù',
  血脉: 'xuè mài',
  血尿: 'xuè niào',
  血泡: 'xuè pào',
  血气: 'xuè qì',
  血亲: 'xuè qīn',
  血清: 'xuè qīng',
  血球: 'xuè qiú',
  血肉: 'xuè ròu',
  血色: 'xuè sè',
  血书: 'xuè shū',
  血栓: 'xuè shuān',
  血统: 'xuè tǒng',
  血污: 'xuè wū',
  血洗: 'xuè xǐ',
  血水: 'xuè shuǐ',
  血丝: 'xuè sī',
  血象: 'xuè xiàng',
  血腥: 'xuè xīng',
  血型: 'xuè xíng',
  血压: 'xuè yā',
  血虚: 'xuè xū',
  血性: 'xuè xìng',
  血液: 'xuè yè',
  血衣: 'xuè yī',
  血印: 'xuè yìn',
  血缘: 'xuè yuán',
  血债: 'xuè zhài',
  血晕: 'xiě yùn',
  血战: 'xuè zhàn',
  血证: 'xuè zhèng',
  血肿: 'xuè zhǒng',
  血渍: 'xuè zì',
  寻思: 'xín sī',
  巡查: 'xún zhā',
  巡行: 'xún xíng',
  巡更: 'xún gēng',
  询查: 'xún zhā',
  丫杈: 'yā chà',
  殉难: 'xùn nàn',
  压板: 'yà bǎn',
  丫头: 'yā tou',
  压倒: 'yā dǎo',
  压轴: 'yā zhòu',
  呀呀: 'yā yā',
  押当: 'yā dàng',
  押解: 'yā jiè',
  押头: 'yā tou',
  桠杈: 'yā chà',
  哑哑: 'yā yā',
  雅乐: 'yǎ yuè',
  雅量: 'yǎ liàng',
  雅兴: 'yǎ xìng',
  咽喉: 'yān hóu',
  咽气: 'yàn qì',
  咽头: 'yān tóu',
  咽炎: 'yān yán',
  淹没: 'yān mò',
  湮没: 'yān mò',
  湮灭: 'yān miè',
  腌臜: 'ā zā',
  严查: 'yán zhā',
  严处: 'yán chǔ',
  芫荽: 'yán sui',
  言行: 'yán xíng',
  盐分: 'yán fèn',
  奄然: 'yǎn rán',
  奄忽: 'yǎn hū',
  奄奄: 'yǎn yǎn',
  厌恶: 'yàn wù',
  砚台: 'yàn tāi',
  验查: 'yàn zhā',
  验血: 'yàn xuè',
  燕京: 'yān jīng',
  燕麦: 'yān mài',
  燕山: 'yān shān',
  燕赵: 'yān zhào',
  燕子: 'yàn zi',
  扬场: 'yáng cháng',
  羊圈: 'yáng juàn',
  洋相: 'yáng xiàng',
  仰给: 'yǎng jǐ',
  养分: 'yǎng fèn',
  吆喝: 'yāo he',
  妖娆: 'yāo ráo',
  腰杆: 'yāo gǎn',
  腰俞: 'yāo yú',
  繇役: 'yáo yì',
  窈窕: 'yǎo tiǎo',
  要得: 'yào de',
  要好: 'yāo hǎo',
  要击: 'yāo jī',
  要求: 'yāo qiú',
  要塞: 'yào sài',
  要挟: 'yāo xié',
  耶教: 'yē jiào',
  耶稣: 'yē sū',
  叶鞘: 'yè qiào',
  叶韵: 'xié yùn',
  叶子: 'yè zi',
  夜曲: 'yè qǔ',
  夜行: 'yè xíng',
  一撮: 'yī zuǒ',
  一得: 'yī de',
  一度: 'yí dù',
  一发: 'yī fà',
  一服: 'yī fù',
  一个: 'yí gè',
  一晃: 'yī huǎng',
  一觉: 'yī jiào',
  一宿: 'yī xiǔ',
  一行: 'yī xíng',
  一应: 'yī yīng',
  一种: 'yī zhǒng',
  伊吾: 'yī wú',
  衣冠: 'yì guān',
  衣着: 'yī zhuó',
  咿呀: 'yī yā',
  遗少: 'yí shào',
  以还: 'yǐ huán',
  以为: 'yǐ wéi',
  义行: 'yì xíng',
  役畜: 'yì xù',
  意兴: 'yì xìng',
  臆度: 'yì duó',
  阴干: 'yīn gàn',
  荫蔽: 'yīn bì',
  荫翳: 'yīn yì',
  音调: 'yīn diào',
  音乐: 'yīn yuè',
  音量: 'yīn liàng',
  殷红: 'yān hóng',
  吟哦: 'yín é',
  引得: 'yǐn de',
  引种: 'yǐn zhǒng',
  饮弹: 'yǐn dàn',
  印行: 'yìn xíng',
  应当: 'yīng dāng',
  应得: 'yīng de',
  应分: 'yīng fèn',
  应和: 'yìng hè',
  应该: 'yīng gāi',
  应届: 'yīng jiè',
  应声: 'yīng shēng',
  应许: 'yīng xǔ',
  应有: 'yīng yǒu',
  应允: 'yīng yǔn',
  鹰爪: 'yīng zhǎo',
  荥阳: 'xíng yáng',
  赢得: 'yíng de',
  影调: 'yǐng diào',
  影片: 'yǐng piān',
  佣工: 'yōng gōng',
  佣人: 'yōng rén',
  拥塞: 'yōng sè',
  壅塞: 'yōng sè',
  用处: 'yòng chǔ',
  忧闷: 'yōu mèn',
  由得: 'yóu de',
  由头: 'yóu tou',
  犹疑: 'yóu nǐ',
  邮差: 'yóu chāi',
  油坊: 'yóu fáng',
  柚木: 'yóu mù',
  有得: 'yǒu de',
  有为: 'yǒu wéi',
  有种: 'yǒu zhǒng',
  右行: 'yòu xíng',
  诱降: 'yòu xiáng',
  淤塞: 'yū sè',
  淤血: 'yū xuè',
  瘀血: 'yū xuè',
  于思: 'yú sāi',
  余量: 'yú liàng',
  余切: 'yú qiē',
  余兴: 'yú xìng',
  於菟: 'wū tú',
  鱼肚: 'yú dǔ',
  鱼种: 'yú zhǒng',
  俞允: 'yú yǔn',
  逾分: 'yú fèn',
  愚氓: 'yú méng',
  瑜伽: 'yú jiā',
  与会: 'yù huì',
  与闻: 'yù wén',
  雨量: 'yǔ liàng',
  语调: 'yǔ diào',
  语塞: 'yǔ sè',
  语种: 'yǔ zhǒng',
  吁请: 'yù qǐng',
  吁求: 'yù qiú',
  芋头: 'yù tou',
  育种: 'yù zhǒng',
  郁闷: 'yù mèn',
  浴血: 'yù xuè',
  预行: 'yù xíng',
  元朝: 'yuán cháo',
  元曲: 'yuán qǔ',
  原处: 'yuán chǔ',
  缘簿: 'yuán bù',
  远行: 'yuǎn xíng',
  月氏: 'ròu zhī',
  月相: 'yuè xiàng',
  月晕: 'yuè yùn',
  钥匙: 'yào shi',
  云量: 'yún liàng',
  匀称: 'yún chèn',
  允当: 'yǔn dàng',
  运量: 'yùn liàng',
  运行: 'yùn xíng',
  运载: 'yùn zài',
  运转: 'yùn zhuàn',
  晕场: 'yùn chǎng',
  晕车: 'yùn chē',
  晕池: 'yùn chí',
  晕船: 'yùn chuán',
  晕倒: 'yūn dǎo',
  晕高: 'yùn gāo',
  晕针: 'yùn zhēn',
  韵调: 'yùn diào',
  熨帖: 'yù tiē',
  杂处: 'zá chǔ',
  杂种: 'zá zhǒng',
  灾难: 'zāi nàn',
  栽倒: 'zāi dǎo',
  宰相: 'zǎi xiàng',
  载波: 'zài bō',
  载荷: 'zài hè',
  载货: 'zài huò',
  载频: 'zài pín',
  载运: 'zài yùn',
  载重: 'zài zhòng',
  再行: 'zài xíng',
  在朝: 'zài cháo',
  咱家: 'zá jiā',
  咱们: 'zán men',
  攒动: 'cuán dòng',
  攒盒: 'cuán hé',
  攒集: 'cuán jí',
  攒聚: 'cuán jù',
  攒眉: 'cuán méi',
  攒射: 'cuán shè',
  暂行: 'zàn xíng',
  臧否: 'zāng pǐ',
  遭难: 'zāo nàn',
  早朝: 'zǎo cháo',
  灶头: 'zào tou',
  择菜: 'zhái cài',
  择席: 'zhái xí',
  责令: 'zé lìng',
  责打: 'zé dǎ',
  责难: 'zé nàn',
  责任: 'zé rèn',
  曾祖: 'zēng zǔ',
  曾孙: 'zēng sūn',
  增长: 'zēng zhǎng',
  增量: 'zēng liàng',
  憎恶: 'zēng wù',
  咋舌: 'zé shé',
  扎染: 'zā rǎn',
  扎挣: 'zhá zhēng',
  轧钢: 'zhá gāng',
  诈降: 'zhà xiáng',
  栅极: 'shān jí',
  炸弹: 'zhà dàn',
  炸糕: 'zhá gāo',
  炸酱: 'zhá jiàng',
  粘结: 'nián jié',
  占卜: 'zhān bǔ',
  占卦: 'zhān guà',
  占课: 'zhān kè',
  占梦: 'zhān mèng',
  占星: 'zhān xīng',
  战将: 'zhàn jiàng',
  战斗: 'zhàn dòu',
  站长: 'zhàn zhǎng',
  帐簿: 'zhàng bù',
  账簿: 'zhàng bù',
  招降: 'zhāo xiáng',
  招徕: 'zhāo lái',
  找头: 'zhǎo tou',
  兆头: 'zhào tou',
  照片: 'zhào piān',
  照相: 'zhào xiàng',
  遮荫: 'zhē yīn',
  折本: 'shé běn',
  折秤: 'shé chèng',
  折堕: 'shé duò',
  折耗: 'shé hào',
  折辱: 'shé rǔ',
  折损: 'shé sǔn',
  折腾: 'zhē téng',
  折头: 'zhé tou',
  折衷: 'shé zhōng',
  这些: 'zhèi xiē',
  侦查: 'zhēn zhā',
  侦缉: 'zhēn jī',
  真率: 'zhēn shuài',
  真相: 'zhēn xiàng',
  枕头: 'zhěn tou',
  争得: 'zhēng de',
  争斗: 'zhēng dòu',
  征调: 'zhēng diào',
  挣揣: 'zhèng chuài',
  挣扎: 'zhēng zhá',
  正传: 'zhèng zhuàn',
  正旦: 'zhēng dàn',
  正切: 'zhèng qiē',
  正朔: 'zhēng shuò',
  正行: 'zhèng xíng',
  正月: 'zhēng yuè',
  症结: 'zhēng jié',
  支差: 'zhī chāi',
  支吾: 'zhī wú',
  吱扭: 'zī niǔ',
  枝杈: 'zhī chà',
  枝干: 'zhī gàn',
  枝蔓: 'zhī wàn',
  知了: 'zhī liǎo',
  执拗: 'zhí niù',
  执著: 'zhí zhuó',
  执行: 'zhí xíng',
  执着: 'zhí zhuó',
  直率: 'zhí shuài',
  直行: 'zhí xíng',
  值当: 'zhí dàng',
  值得: 'zhí de',
  止血: 'zhǐ xuè',
  只当: 'zhǐ dāng',
  只得: 'zhǐ de',
  只顾: 'zhǐ gù',
  只好: 'zhǐ hǎo',
  只管: 'zhǐ guǎn',
  只怕: 'zhǐ pà',
  只能: 'zhǐ néng',
  只是: 'zhǐ shì',
  只消: 'zhǐ xiāo',
  只要: 'zhǐ yào',
  只有: 'zhǐ yǒu',
  纸夹: 'zhǐ jiā',
  指缝: 'zhǐ féng',
  指头: 'zhǐ tou',
  至为: 'zhì wéi',
  治丧: 'zhì sāng',
  质量: 'zhì liàng',
  质朴: 'zhì piáo',
  中标: 'zhòng biāo',
  中彩: 'zhòng cǎi',
  中弹: 'zhòng dàn',
  中都: 'zhōng dōu',
  中毒: 'zhòng dú',
  中风: 'zhòng fēng',
  中计: 'zhòng jì',
  终了: 'zhōng liǎo',
  衷曲: 'zhōng qǔ',
  种别: 'zhǒng bié',
  种草: 'zhǒng cǎo',
  种差: 'zhǒng chà',
  种蛋: 'zhǒng dàn',
  种类: 'zhǒng lèi',
  种麻: 'zhǒng má',
  种马: 'zhǒng mǎ',
  种禽: 'zhǒng qín',
  种群: 'zhǒng qún',
  种系: 'zhǒng xì',
  种姓: 'zhǒng xìng',
  种畜: 'zhǒng chù',
  种种: 'zhǒng zhǒng',
  种籽: 'zhǒng zǐ',
  种子: 'zhǒng zi',
  种族: 'zhǒng zú',
  重版: 'chóng bǎn',
  重播: 'chóng bō',
  重唱: 'chóng chàng',
  重创: 'zhòng chuāng',
  重出: 'chóng chū',
  重担: 'zhòng dàn',
  重弹: 'chóng tán',
  重叠: 'chóng dié',
  重返: 'chóng fǎn',
  重犯: 'chóng fàn',
  重逢: 'chóng féng',
  重复: 'chóng fù',
  重光: 'chóng guāng',
  重合: 'chóng hé',
  重荷: 'zhòng hè',
  重婚: 'chóng hūn',
  重建: 'chóng jiàn',
  重九: 'chóng jiǔ',
  重聚: 'chóng jù',
  重量: 'zhòng liàng',
  重拍: 'chóng pāi',
  重庆: 'chóng qìng',
  重申: 'chóng shēn',
  重审: 'chóng shěn',
  重生: 'chóng shēng',
  重述: 'chóng shù',
  重数: 'chóng shù',
  重提: 'chóng tí',
  重孙: 'chóng sūn',
  重头: 'chóng tóu',
  重围: 'chóng wéi',
  重温: 'chóng wēn',
  重现: 'chóng xiàn',
  重霄: 'chóng xiāo',
  重新: 'chóng xīn',
  重行: 'chóng xíng',
  重修: 'chóng xiū',
  重演: 'chóng yǎn',
  重阳: 'chóng yáng',
  重洋: 'chóng yáng',
  重译: 'chóng yì',
  重印: 'chóng yìn',
  重影: 'chóng yǐng',
  重映: 'chóng yìng',
  重圆: 'chóng yuán',
  重载: 'zhòng zài',
  重责: 'zhòng zé',
  重重: 'chóng chóng',
  重奏: 'chóng zòu',
  州长: 'zhōu zhǎng',
  周正: 'zhōu zhēng',
  主调: 'zhǔ diào',
  主干: 'zhǔ gàn',
  主角: 'zhǔ jué',
  主将: 'zhǔ jiàng',
  助长: 'zhù zhǎng',
  助兴: 'zhù xìng',
  抓差: 'zhuā chāi',
  抓斗: 'zhuā dòu',
  爪哇: 'zhǎo wā',
  爪牙: 'zhǎo yá',
  专差: 'zhuān chāi',
  专横: 'zhuān hèng',
  转调: 'zhuǎn diào',
  转动: 'zhuàn dòng',
  转干: 'zhuǎn gàn',
  转筋: 'zhuàn jīn',
  转矩: 'zhuàn jǔ',
  转炉: 'zhuàn lú',
  转轮: 'zhuàn lún',
  转门: 'zhuàn mén',
  转磨: 'zhuàn mò',
  转圈: 'zhuàn quān',
  转速: 'zhuàn sù',
  转台: 'zhuàn tái',
  转文: 'zhuǎi wén',
  转椅: 'zhuàn yǐ',
  转悠: 'zhuàn yōu',
  转圜: 'zhuǎn huán',
  转子: 'zhuàn zǐ',
  赚头: 'zhuàn tou',
  赚得: 'zuàn de',
  撰著: 'zhuàn zhe',
  幢幢: 'chuáng chuáng',
  追查: 'zhuī zhā',
  追还: 'zhuī huán',
  追缉: 'zhuī jī',
  准将: 'zhǔn jiàng',
  准头: 'zhǔn tou',
  拙朴: 'zhuō piáo',
  茁长: 'zhuó zhǎng',
  酌处: 'zhuó chǔ',
  酌量: 'zhuó liàng',
  着边: 'zhuó biān',
  着凉: 'zháo liáng',
  着迷: 'zháo mí',
  着数: 'zhāo shù',
  着意: 'zhuó yì',
  仔鸡: 'zǐ jī',
  仔肩: 'zǐ jiān',
  仔密: 'zǐ mì',
  仔细: 'zǐ xì',
  仔畜: 'zǐ chù',
  仔猪: 'zǐ zhū',
  仔鱼: 'zǐ yú',
  趑趄: 'zī jū',
  籽种: 'zǐ zhǒng',
  子弹: 'zǐ dàn',
  字调: 'zì diào',
  字模: 'zì mú',
  字帖: 'zì tiè',
  自传: 'zì zhuàn',
  自给: 'zì jǐ',
  自矜: 'zì jīn',
  自禁: 'zì jīn',
  自量: 'zì liàng',
  自省: 'zì xǐng',
  自行: 'zì xíng',
  自转: 'zì zhuàn',
  总长: 'zǒng zhǎng',
  总得: 'zǒng děi',
  总量: 'zǒng liàng',
  总行: 'zǒng xíng',
  走调: 'zǒu diào',
  奏乐: 'zòu yuè',
  租种: 'zū zhǒng',
  阻难: 'zǔ nàn',
  阻塞: 'zǔ sè',
  组分: 'zǔ fèn',
  组曲: 'zǔ qǔ',
  钻洞: 'zuān dòng',
  钻杆: 'zuàn gǎn',
  钻劲: 'zuān jìn',
  钻孔: 'zuān kǒng',
  钻谋: 'zuān móu',
  钻探: 'zuān tàn',
  钻心: 'zuān xīn',
  钻研: 'zuān yán',
  钻营: 'zuān yíng',
  罪行: 'zuì xíng',
  遵行: 'zūn xíng',
  作坊: 'zuō fang',
  作乐: 'zuò yuè',
  作弄: 'zuō nòng',
  作曲: 'zuò qǔ',
  作为: 'zuò wéi',
  坐禅: 'zuò chán',
  柞蚕: 'zuò cán',
};
export default DICT2;
